<template>
  <div>
    <Layout :isSuccess="true" class-container="pt-0">
      <template v-slot:containerZone>
        <div class="intro-header mb-4">Overview</div>
        <div class="px-3 mb-3">
          <v-card elevation="0" class="my-2">
            <div class="box-filter">
              <div>
                <div class="txt-title">{{ $t('project.project_overview') }}</div>
                <div class="txt-sub">{{ $t('project.according_to_the_date_you_selected') }}</div>
              </div>
              <div class="filter">
                <date-range-picker ref="picker" :locale-data="optionsDateRange" :autoApply="false"
                  v-model="filterData.dateRange" :ranges="ranges"
                  :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct">
                  <template v-slot:input="picker" style="min-width: 350px;" class="custom-date-range">
                    <div class="icon-prepend">
                      <v-icon size="24px">mdi-calendar-range</v-icon>
                    </div>
                    {{ $helper.datelabel(picker.startDate) }} - {{ $helper.datelabel(picker.endDate) }}
                  </template>
                  <!-- <template v-slot:footer="picker">
                  <div class="custom-footer">
                    Selected Range: {{ $moment(picker.startDate).format(momentDateFormat) }} - {{ $moment(picker.endDate).format(momentDateFormat) }}
                  </div>
                </template> -->
                </date-range-picker>
                <v-autocomplete v-model="filterData.marketId"
                  :items="[{ name: $t('all'), objectId: '' }, ...filterOptions.selectMarket]" item-text="name"
                  item-value="objectId" :placeholder="$t('market.select_market')" hide-details outlined dense
                  elevation="0" background-color="white lighten-4"
                  :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct"
                  style="min-width:200px;" @change="onChangeMarket()">
                </v-autocomplete>
                <v-select v-model="filterData.type" :items="filterOptions.selectType" item-text="text"
                  item-value="value" :placeholder="$t('project.show_by_square_meter')" hide-details outlined dense
                  elevation="0" background-color="white lighten-4" :no-data-text="$t('noinfo')"
                  :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct"
                  style="width:200px;" @change="onChangeMarket()">
                </v-select>

                <v-btn @click="onSearch()" class="primary"
                  :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct">
                  <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
                </v-btn>
                <!-- <v-btn @click="test()" class="primary" :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct">
                  <v-icon>mdi-magnify</v-icon>ค้นหา
                </v-btn> -->
              </div>
            </div>
          </v-card>

          <template>
            <v-container class="scope-card-summary px-0" :fluid="true">
              <v-row>
                <v-col cols-lg="3" lg="3" md="6" v-for="(summary, inx) in summarysData" :key="inx">
                  <v-card elevation="0" :class="[
                    { 'active': summary.type == isActiveType },
                    { 'disable-events': summary.type == 'rental_rate' && isLoadingRentalRate },
                    { 'disable-events': summary.type !== 'rental_rate' && isLoadingIncome },
                    'box-summary']" @click="getChartType(summary);">
                    <div class="detail">
                      <div class="txt-title">{{ summary.title }}</div>
                      <div class="count">
                        {{ summary.currency == 'bath' ? $helper.toCurrency(summary.value, null, { isPrefixSign: true })
                          :
                          $helper.toCurrency(summary.value) + '%' }}
                      </div>
                      <v-tooltip bottom color="rgba(0, 0, 0, 0.7)">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" class="percent">
                            <div class="icon">
                              <img v-if="summary.rateType == 'plus'" width="31"
                                :src="require(`@/assets/images/percent-up.svg`)" />
                              <img v-else-if="summary.rateType == 'minus'" width="31"
                                :src="require(`@/assets/images/percent-down.svg`)" />
                            </div>
                            <div :class="getRateClass(summary.rateType)">
                              {{ summary.rate === "Infinity" ? '0' : (summary.rate > 0 ? '+' +
                                $helper.toCurrency(summary.rate) : $helper.toCurrency(summary.rate)) }}%
                            </div>
                          </div>
                        </template>
                        <div class="tooltip-box py-1">
                          {{ $t('project.compare_with_period', {
                            start:
                              $moment(summary.startDate).format(momentDateFormat), end:
                              $moment(summary.endDate).format(momentDateFormat), title: summary.title, value:
                              summary.currency == 'bath' ?
                                $helper.toCurrency(summary.previousValue, null, { isSuffixSign: true }) :
                                $helper.toCurrency(summary.previousValue) +
                                '%'
                          }) }}
                          <div class="d-flex justify-between mt-1">
                            <div class="txt-hl">
                              <div class="txt-title">{{ $t('project.make_it_have', { title: summary.title }) }}</div>
                              <div style="padding-left: 5px;" :class="getRateClass(summary.rateType)">
                                {{ summary.rateType == 'plus' ? $t('increase') : $t('decrease') }}
                                <span v-if="summary.type != 'rental_rate'">
                                  {{ summary.rateType == 'plus' ? '+' : '' }}{{ $helper.toCurrency(summary.value -
                                    summary.previousValue, null, {
                                    isSuffixSign: true
                                  }) }}</span>
                              </div>
                            </div>
                            <div class="percent">
                              <div class="icon">
                                <img v-if="summary.rateType == 'plus'" width="31"
                                  :src="require(`@/assets/images/percent-up.svg`)" />
                                <img v-else-if="summary.rateType == 'minus'" width="31"
                                  :src="require(`@/assets/images/percent-down.svg`)" />
                              </div>
                              <div :class="getRateClass(summary.rateType)">
                                {{ summary.rate > 0 ? '+' + $helper.toCurrency(summary.rate) :
                                  $helper.toCurrency(summary.rate) }}%
                              </div>
                            </div>
                          </div>
                          <div v-if="summary.type == 'rental_rate'" class="d-flex justify-between mt-1">
                            <div class="txt-hl">
                              <div class="txt-title">{{ $t('project.and_make_it_have', { title: summary.title }) }}
                              </div>
                              <div style="padding-left: 5px;" :class="getRateClass(summary.rateType)">
                                {{ summary.rateType == 'plus' ? $t('increase') : $t('decrease') }}
                              </div>
                            </div>
                            <div class="percent">
                              <div class="icon">
                                <img v-if="summary.rateType == 'plus'" width="31"
                                  :src="require(`@/assets/images/percent-up.svg`)" />
                                <img v-else-if="summary.rateType == 'minus'" width="31"
                                  :src="require(`@/assets/images/percent-down.svg`)" />
                              </div>
                              <div :class="`${summary.growthRate >= 0 ? 'txt-success' : 'txt-danger'}`">
                                {{ summary.growthRate > 0 ? '+' + $helper.toCurrency(summary.growthRate) :
                                  $helper.toCurrency(summary.growthRate) }}%
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-tooltip>
                    </div>
                    <template v-if="summary.type == 'rental_rate'">
                      <div class="chart" v-show="!isLoadingRentalRate || !isLoading">
                        <ChartLine :data="summary" :chartData="summary.chartObj" :mode="`summary`" />
                      </div>
                      <v-progress-circular v-if="isLoadingRentalRate || isLoading" indeterminate color="primary"
                        size="20"></v-progress-circular>
                    </template>
                    <template v-else>
                      <div class="chart" v-show="!isLoadingIncome || !isLoading">
                        <ChartLine :data="summary" :chartData="summary.chartObj" :mode="`summary`" />
                      </div>
                      <v-progress-circular v-if="isLoadingIncome || isLoading" indeterminate color="primary"
                        size="20"></v-progress-circular>
                    </template>

                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-if="isActiveType == 'rental_rate'">
            <v-card class="bar-chart-box mt-2" elevation="0">
              <div class="header mb-2">
                <div class="title-text">
                  <div class="txt-title d-flex align-center">
                    {{ $t('area.rental_rate') }}
                    <v-progress-circular class="ms-2" v-if="isLoadingRentalRate || isLoading" indeterminate
                      color="primary" size="20"></v-progress-circular>
                  </div>
                  <div class="d-flex align-center">
                    <div class="sub-title secondary me-1">
                      {{ $t('area.average_rental_rate') }}
                    </div>
                    <div class="txt-title mb-1">
                      {{ $helper.toCurrency(getDataRentalRate(filterData.marketId).rentalAreaOccupiedPercent) }}%</div>
                  </div>
                </div>
                <div id="custom-bar-legend" class="legend-inline"></div>
              </div>
              <div class="body">
                <div class="box-chart-rental position-relative">
                  <canvas id="bar-chart"></canvas>
                </div>
              </div>
            </v-card>
          </template>
          <template v-else-if="isActiveType !== 'rental_rate'">
            <div class="box-pie-income mb-3">
              <v-card elevation="0" class="wrapper">
                <div class="grid-col-1">
                  <div class="header">
                    <div class="txt-title">{{ $t('project.summary', { title: textTitleMainChart }) }}</div>
                    <div class="sub-title">{{ $t('project.summary_market_income', { title: textTitleMainChart }) }}
                    </div>
                  </div>
                  <div class="body">
                    <div class="total-income-box" v-show="dataIncomePrepare">
                      <div class="doughnut-chart-box position-relative">
                        <canvas id="doughnut-chart-total-income"></canvas>
                      </div>
                      <div id="custom-total-income-doughnut-legend" class="market-legend"></div>
                    </div>
                    <div v-show="!dataIncomePrepare" class="no-data ps-2">
                      {{ $t('no_list') }}
                    </div>
                  </div>
                </div>
                <div class="grid-col-2">
                  <div class="body">
                    <div class="total-income-box"
                      v-show="dataAccountingProductPrepare && dataAccountingProductPrepare.accountingProduct">
                      <div class="chart-pie-income-box position-relative">
                        <canvas id="pie-chart-total-income" v-show="dataAccountingProductPrepare"></canvas>
                      </div>
                      <div id="custom-total-income-pie-legend" class="market-legend"></div>
                    </div>
                    <div v-show="!dataAccountingProductPrepare || !dataAccountingProductPrepare.accountingProduct"
                      class="no-data txt-title ps-2 pt-4">
                      {{ $t('no_list') }}
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </template>

          <template>
            <div class="scope-container-overview">
              <div class="grid-col">
                <div class="box-rank">
                  <v-card elevation="0" class="wrapper">
                    <div class="header mb-3">
                      <div>
                        <div class="txt-title">{{ getDataDetailBoxRank.title }}</div>
                        <div class="sub-title">{{ getDataDetailBoxRank.subTitle }}</div>
                      </div>
                      <div>
                        <v-select v-model="filterData.rankType" item :items="filterOptions.rankType" item-text="text"
                          item-value="value" :label="$t('product.select_rank_list')" solo hide-details flat
                          style="width:250px" background-color="grey lighten-4" @change="changeRankType($event);"
                          :no-data-text="$t('noinfo')"
                          :disabled="isLoading || isSearching || isLoadArea || isLoadingIncome || isLoadingAccountingProduct || isLoadingRentalRate || isLoadingProduct">
                        </v-select>
                      </div>
                    </div>
                    <div :class="['body', getDataDetailBoxRank.color]">
                      <template v-if="filterData.rankType != 'top_traders'">
                        <div>
                          <div v-for="(market, inx) in getRankData" :key="'market-top-traders-' + market.objectId">
                            <div v-if="!filterData.marketId"
                              :class="[{ 'active': isMarketActive == market.objectId }, 'box-rank-market mb-3']"
                              :key="market.objectId" @click="initMarketChart(market)">
                              <div class="detail">
                                <div class="number">{{ inx + 1 }}</div>
                                <div>
                                  <div class="sub-title">{{ $t('rank') }} {{ inx + 1 }}</div>
                                  <div class="name">{{ market.name }}</div>
                                </div>
                              </div>
                              <div class="progress">
                                <div class="box-abs-chart-mini">
                                  <div v-if="filterData.rankType == 'rental_rate'" class="chart-mini">
                                    <chart-line :data="prepareDataRentalRate(getDataRentalRate(market.objectId))"
                                      :chartData="prepareDataRentalRate(getDataRentalRate(market.objectId)).rentalRate"
                                      :color="colorLineChart">
                                    </chart-line>
                                  </div>
                                  <div v-if="filterData.rankType == 'total_income'" class="chart-mini">
                                    <chart-line :data="prepareDataIncome(getDataIncome(market.objectId))"
                                      :chartData="prepareDataIncome(getDataIncome(market.objectId)).incomeTotal"
                                      :color="colorLineChart">
                                    </chart-line>
                                  </div>
                                  <div v-if="filterData.rankType == 'income_meters'" class="chart-mini">
                                    <chart-line :data="prepareDataIncome(getDataIncome(market.objectId))"
                                      :chartData="prepareDataIncome(getDataIncome(market.objectId)).incomeAreaAvg"
                                      :color="colorLineChart" />
                                  </div>
                                  <v-progress-linear class="abs-progress-bar"
                                    :value="market.data.rentalAreaOccupiedPercent" color="yellow darken-2" height="4"
                                    v-if="filterData.rankType == 'rental_rate'"></v-progress-linear>
                                </div>
                                <div v-if="filterData.rankType == 'rental_rate'" class="txt-value">
                                  <span v-if="!isLoadingRentalRate">{{
                                    $helper.toCurrency(market.data.rentalAreaOccupiedPercent) }}%</span>
                                  <v-progress-circular v-if="isLoadingRentalRate" indeterminate color="primary"
                                    size="20"></v-progress-circular>
                                </div>
                                <div v-else-if="filterData.rankType == 'total_income'" class="txt-value">
                                  <span v-if="!isLoadingIncome">
                                    {{ market.data.totalIncomeValue | currencyPrefixSign(null, {
                                      isAbbreviate: true,
                                      isNoSpace: true
                                    }) }}
                                  </span>
                                  <v-progress-circular v-if="isLoadingIncome" indeterminate color="primary"
                                    size="20"></v-progress-circular>
                                </div>
                                <div v-else-if="filterData.rankType == 'income_meters'" class="txt-value">
                                  <span v-if="!isLoadingIncome">
                                    {{ market.data.totalIncomeValueAvgSizeMeter | currencyPrefixSign(null, {
                                      isAbbreviate: true, isNoSpace: true
                                    }) }}
                                  </span>
                                  <v-progress-circular v-if="isLoadingIncome" indeterminate color="primary"
                                    size="20"></v-progress-circular>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="filterData.marketId && filterData.marketId == market.objectId"
                              :class="[{ 'active': isMarketActive == market.objectId }, 'box-rank-market mb-3']"
                              @click="initMarketChart(market)">
                              <div class="detail">
                                <div class="number">{{ inx + 1 }}</div>
                                <div>
                                  <div class="sub-title">{{ $t('rank') }} {{ inx + 1 }}</div>
                                  <div class="name">{{ market.name }}</div>
                                </div>
                              </div>
                              <div class="progress">
                                <div class="box-abs-chart-mini">
                                  <div v-if="filterData.rankType == 'rental_rate'" class="chart-mini">
                                    <chart-line :data="prepareDataRentalRate(getDataRentalRate(market.objectId))"
                                      :chartData="prepareDataRentalRate(getDataRentalRate(market.objectId)).rentalRate"
                                      :color="colorLineChart">
                                    </chart-line>
                                  </div>
                                  <div v-if="filterData.rankType == 'total_income'" class="chart-mini">
                                    <chart-line :data="prepareDataIncome(getDataIncome(market.objectId))"
                                      :chartData="prepareDataIncome(getDataIncome(market.objectId)).incomeTotal"
                                      :color="colorLineChart">
                                    </chart-line>
                                  </div>
                                  <div v-if="filterData.rankType == 'income_meters'" class="chart-mini">
                                    <chart-line :data="prepareDataIncome(getDataIncome(market.objectId))"
                                      :chartData="prepareDataIncome(getDataIncome(market.objectId)).incomeAreaAvg"
                                      :color="colorLineChart">
                                    </chart-line>
                                  </div>
                                  <v-progress-linear class="abs-progress-bar"
                                    :value="market.data.rentalAreaOccupiedPercent" color="yellow darken-2" height="4"
                                    v-if="filterData.rankType == 'rental_rate'"></v-progress-linear>
                                </div>
                                <div v-if="filterData.rankType == 'rental_rate'" class="txt-value">
                                  {{ $helper.toCurrency(market.data.rentalAreaOccupiedPercent) }}%
                                </div>
                                <div v-else-if="filterData.rankType == 'total_income'" class="txt-value">
                                  {{ market.data.totalIncomeValue | currencyPrefixSign(null, {
                                    isAbbreviate: true,
                                    isNoSpace: true
                                  }) }}
                                </div>
                                <div v-else-if="filterData.rankType == 'income_meters'" class="txt-value">
                                  {{ market.data.totalIncomeValueAvgSizeMeter | currencyPrefixSign(null, {
                                    isAbbreviate:
                                      true, isNoSpace: true
                                  }) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-if="!isLoadingCustomerRanking && filterData.rankType == 'top_traders'">
                        <div>
                          <div v-for="(customer, inx) in customer"
                            :class="[{ 'active': isActiveCustomer == customer.objectId }, 'box-rank-market']" :key="inx"
                            @click="isActiveCustomer = customer.objectId">
                            <div class="detail">
                              <div class="number">{{ inx + 1 }}</div>
                              <div>
                                <div class="sub-title">{{ $t('rank') }} {{ inx + 1 }}</div>
                                <div class="name">{{ customer.name }}</div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="box-abs-chart-mini">
                                <div class="chart-mini">
                                  <chart-line :data="customer.data" :chartData="customer.data"
                                    :color="colorLineChart"></chart-line>
                                </div>
                              </div>
                              <div class="txt-value">
                                {{ customer.totalValue | currencyPrefixSign(null, {
                                  isAbbreviate: true, isNoSpace: true
                                }) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-card>
                </div>
              </div>
              <div class="grid-col">
                <div class="box-chart-income bd-bottom mb-4">
                  <v-card elevation="0" class="wrapper">
                    <div class="header">
                      <div class="title-section">
                        <div class="sub-title">{{ $t('product.total_income_market', { name: marketName }) }}</div>
                        <div class="txt-title">{{ getDataIncome(isMarketActive).totalIncomeValue |
                          currencySuffixTextThEn }}</div>
                      </div>
                      <div id="custom-legend" class="legend-inline"></div>
                    </div>
                    <div class="body">
                      <div class="barchart-income" style="position: relative;">
                        <canvas id="bar-chart-overview-income"
                          v-show="dataIncomePrepare && !isLoadingIncome && !isLoading"></canvas>
                        <div class="no-data" v-if="!(dataIncomePrepare) || isLoadingIncome || isLoading">
                          <div v-if="!isLoadingIncome">{{ $t('no_income') }}</div>
                          <div v-else class="d-flex align-center justify-center pt-5">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </div>
                <div class="box-chart-type bd-bottom">
                  <v-card elevation="0" class="wrapper">
                    <div class="col-left">
                      <div class="header">
                        <div class="sub-title">{{ $t('product.product_type_of_market', { name: marketName }) }}</div>
                        <div class="txt-title">{{ $t('product.product_type_of_market_ratio') }}</div>
                      </div>
                      <div class="body">
                        <div id="custom-pie-legend" class="product-category"></div>
                      </div>
                    </div>
                    <div class="col-right">
                      <div class="pie-chart-box position-relative">
                        <canvas id="pie-chart-product-category"
                          v-show="dataProductPrepare && !isLoadingProduct && !isLoading"></canvas>
                        <div class="no-data" v-if="!(dataProductPrepare) || isLoadingProduct || isLoading">
                          <div v-if="!isLoadingProduct">{{ $t('product.no_product') }}</div>
                          <div v-else class="d-flex align-center justify-center pt-5">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </div>
              </div>
            </div>
          </template>
        </div>

        <template v-if="project">
          <div class="px-3 mt-4">
            <div :class="['box-areaplan', { 'd-flex align-center justify-center': isLoadArea || isLoading }]">
              <MarketPlan
                v-if="!isLoadArea && !isLoading && filterData.areaMarketIdFirst && dataArea && project.layoutType == 2"
                :projectId="projectId" :isEdit="false" :marketId="filterData.areaMarketIdFirst" :mode="`occrate`"
                :areaOccrateData="dataArea" :marketData="filterOptions.selectMarket"
                :selectMarketArea.sync="filterData.areaMarketIdFirst" :tooltipStallId="'tooltipStallId1'"
                @change="changeMarketArea" />
              <MarketPlan
                v-if="!isLoadArea && !isLoading && filterData.areaMarketId && dataArea && project.layoutType == 1"
                :projectId="projectId" :isEdit="false" :marketId="filterData.areaMarketId" :mode="`occrate`"
                :areaOccrateData="dataArea" :marketData="filterOptions.selectMarket"
                :selectMarketArea.sync="filterData.areaMarketId" :tooltipStallId="'tooltipStallId1'"
                @change="changeMarketArea" />
              <div v-if="isLoadArea || isLoading" class="mt-5">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              </div>
              <ProjectPlanArea
                v-if="!isLoadArea && !isLoading && !filterData.areaMarketId && dataArea && project.layoutType == 1"
                :projectId="projectId" :isEdit="false" :marketId="filterData.areaMarketId" :mode="`occrate`"
                :areaOccrateData="dataArea" :marketData="filterOptions.selectMarket"
                :selectMarketArea.sync="filterData.areaMarketId" @change="changeMarketArea" />
            </div>
          </div>

          <OccrateDialog :marketId="marketId" :projectId="projectId" v-model="isOccRateDialog"
            :dataModalPrepare="dataModalPrepare" :typeChartDialog="typeChartDialog" marketName:marketName />
        </template>
      </template>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Layout from "@/components/Layout.vue";
import ProjectPlanArea from "@/components/ProjectPlanArea.vue";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ChartLine from '@/components/ChartLine.vue';
import OccrateDialog from "../../components/OccrateDialog.component.vue";
import MarketPlan from "../../components/MarketPlan.vue";
import { Market } from "../../classes"
Chart.register(ChartDataLabels);

export default {
  components: {
    Layout,
    DateRangePicker,
    ChartLine,
    ProjectPlanArea,
    OccrateDialog,
    MarketPlan
  },
  data() {
    return {
      momentDateFormat: "D MMM YYYY",
      momentDataFormat: "YYYY-MM-DD",
      projectId: this.$route.params.projectId,
      marketId: "",
      areaId: "",
      project: null,
      isLoading: false,
      isActiveType: 'rental_rate',
      isMarketActive: null,
      isMarketActiveTemp: null,
      isActiveCustomer: null,
      isOccRateDialog: false,
      typeChartDialog: null,
      filterOptions: {
        selectMarket: [],
        selectType: [
          {
            text: this.$t('product.show_by_stall'),
            value: "show_by_area"
          },
          {
            text: this.$t('project.show_by_square_meter'),
            value: "show_by_meters"
          }
        ],
        rankType: [
          {
            text: this.$t('area.rental_rate'),
            value: "rental_rate"
          },
          {
            text: this.$t('project.total_income'),
            value: "total_income"
          },
          {
            text: this.$t('project.income_per_square_meter'),
            value: "income_meters"
          },
          {
            text: this.$t('project.top_traders'),
            value: "top_traders"
          },
        ],
      },
      filterData: {
        dateRange: {
          startDate: this.$moment().subtract(1, 'months').startOf("month").format(this.momentDataFormat),
          endDate: this.$moment().subtract(1, 'months').endOf("month").format(this.momentDataFormat)
        },
        marketId: "",
        type: "show_by_area",
        rankType: "rental_rate",
        areaMarketId: "",
        areaMarketIdFirst: "",
      },
      optionsDateRange: {
        isLoading: false,
        direction: 'ltr',
        format: 'dd/mm/yyyy',
        separator: ' - ',
        applyLabel: this.$t('save'),
        cancelLabel: this.$t('cancel'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: this.$moment.weekdaysShort(),
        monthNames: this.$moment.months(),
        monthNamesShort: this.$moment.monthsShort(),
        firstDay: 1,
      },
      ranges: {
        [this.$t('date_range.today')]: [this.$moment().startOf('day')._d, this.$moment().endOf('day')._d],
        [this.$t('date_range.yesterday')]: [this.$moment().subtract(1, 'days').startOf('day')._d, this.$moment().subtract(1, 'days').endOf('day')._d],
        [this.$t('date_range.this_week')]: [this.$moment().startOf('week')._d, this.$moment().endOf('week')._d],
        [this.$t('date_range.last_week')]: [this.$moment().subtract(1, 'weeks').startOf('week')._d, this.$moment().subtract(1, 'weeks').endOf('week')._d],
        [this.$t('date_range.this_month')]: [this.$moment().startOf('month')._d, this.$moment().endOf('month')._d],
        [this.$t('date_range.last_month')]: [
          this.$moment().subtract(1, 'months').startOf('month')._d,
          this.$moment().subtract(1, 'months').endOf('month')._d
        ],
        [this.$t('date_range.this_year')]: [this.$moment().startOf('year')._d, this.$moment().endOf('year')._d],
        [this.$t('date_range.last_year')]: [
          this.$moment().subtract(1, 'years').startOf('year')._d,
          this.$moment().subtract(1, 'years').endOf('year')._d
        ],
      },
      summarysData: [
        {
          title: this.$t('area.rental_rate'),
          value: 0,
          currency: 'percent',
          rate: 0,
          rateType: 'plus',
          type: 'rental_rate',
          chartData: {},
          startDate: null,
          endDate: null,
        },
        {
          title: this.$t('payment.all_income'),
          value: 0,
          currency: 'bath',
          rate: 0,
          rateType: 'plus',
          type: 'total_income',
          chartData: {},
          startDate: null,
          endDate: null,
        },
        {
          title: this.$t('income.average_daily_income'),
          value: 0,
          currency: 'bath',
          rate: 0,
          rateType: 'plus',
          type: 'income_per_day',
          chartData: {},
          startDate: null,
          endDate: null,
        },
        {
          title: this.$t('income.average_income_per_stall'),
          value: 0,
          currency: 'bath',
          rate: 0,
          rateType: 'plus',
          type: 'income_per_area',
          chartData: {},
          startDate: null,
          endDate: null,
        },
      ],
      barChart: null,
      doughnutChartTotalIncome: null,
      pieChartTotalIncome: null,
      pieChartProductCategorys: null,
      barChartOverviewIncome: null,
      isLoading: false,
      isSearching: false,
      isLoadArea: false,
      isLoadingRentalRate: false,
      isLoadingIncome: false,
      isLoadingAccountingProduct: false,
      isLoadingProduct: false,
      isLoadingCustomerRanking: false,
      dataIncome: null,
      dataIncomePrepare: null,
      dataIncomeByMarket: null,
      dataOccupancy: null,
      dataOccupancyPrepare: null,
      dataRentalRate: null,
      dataRentalRatePrepare: null,
      dataAccountingProduct: null,
      dataAccountingProductPrepare: null,
      dataProduct: null,
      dataProductPrepare: null,
      customerRanking: null,
      customer: null,
      areaOccrateData: {},
      isMountedCheckBarChartInrent: false,
      isMountedCheckBarChartOverviewIncome: false,
      isMountedCheckPieChart: false,
      isMountedCheckDoughnutChartIncome: false,
      isMountedCheckPieChartIncome: false,
      colorLineChart: ['rgba(229, 229, 239, 1)', 'rgba(229, 229, 239, 0.2)'],
      dataDetailBoxRank: {
        title: this.$t('market.market_rank'),
        subTitle: this.$t('market.market_rank_by_tenant'),
        color: 'bg-warning',
      },
      rentalAreaOccupiedPercent: 0,
      rentalAreaSizeOccupiedPercent: 0,
      totalIncomeValueMarket: 0,
      totalIncomeValue: 0,
      totalIncomeValueAvgDay: 0,
      totalIncomeValueAvgSize: 0,
      markets: [],
      marketName: null,
      dataModalPrepare: {},
      textTitleMainChart: this.$t('payment.all_income'),
      dataIncomeByMarket: null,
      dataRentalByMarket: null,
      dataArea: null,
      dataIncomePrevoius: null,
      dataIncomePrevoiusPrepare: null,
      dataOverAll: null,
      summaryStartDate: null,
      summaryEndDate: null,
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins
    }),
    ...mapGetters({
      user: "user/getUser",
      getUserInfo: "user/getUserInfo",
      getByProjectId: "user/getByProjectId",
      market: "markets/getMarket",
      incomeOverall: "invoice/getInvoiceOverall",
      areaOverall: "area/getOverallAreas",
    }),
    getDataDetailBoxRank() {
      if (this.filterData.rankType == 'rental_rate') {
        this.dataDetailBoxRank = {
          title: this.$t('market.market_rank'),
          subTitle: this.$t('market.market_rank_by_tenant'),
          color: 'bg-warning',
        }
      } else if (this.filterData.rankType == 'total_income') {
        this.dataDetailBoxRank = {
          title: this.$t('market.market_rank'),
          subTitle: this.$t('market.market_rank_by_total_income'),
          color: 'bg-green',
        }
      } else if (this.filterData.rankType == 'income_meters') {
        this.dataDetailBoxRank = {
          title: this.$t('market.market_rank'),
          subTitle: this.$t('market.market_rank_by_income_meters'),
          color: 'bg-blue',
        }
      } else if (this.filterData.rankType == 'top_traders') {
        this.dataDetailBoxRank = {
          title: 'Top 20',
          subTitle: this.$t('market.top_twenty_traders'),
          color: 'bg-orange',
        }
      }
      return this.dataDetailBoxRank;
    },
    getRankData() {
      let markets = this.markets;
      let data = [];
      if (markets) {
        for (const key in markets) {
          let marketObjectId = markets[key].objectId;
          let dataRentalRate = this.getDataRentalRate(marketObjectId)
          let dataIncome = this.getDataIncome(marketObjectId)
          let detail = {
            rentalAreaOccupiedPercent: dataRentalRate.rentalAreaOccupiedPercent,
            totalIncomeValue: dataIncome.totalIncomeValue,
            totalIncomeValueAvgSize: dataIncome.totalIncomeValueAvgSize,
            totalIncomeValueAvgSizeMeter: dataIncome.totalIncomeValueAvgSizeMeter,
          }
          data.push({
            name: markets[key].name,
            objectId: marketObjectId,
            data: detail,
          })
        }
      }

      if (this.filterData.rankType == 'rental_rate') {
        data.sort((a, b) => {
          const countA = a.data.rentalAreaOccupiedPercent || 0;
          const countB = b.data.rentalAreaOccupiedPercent || 0;
          return countB - countA;
        });
      } else if (this.filterData.rankType == 'total_income') {
        data.sort((a, b) => {
          const countA = a.data.totalIncomeValue || 0;
          const countB = b.data.totalIncomeValue || 0;
          return countB - countA;
        });
      } else if (this.filterData.rankType == 'income_meters') {
        data.sort((a, b) => {
          const countA = a.data.totalIncomeValueAvgSizeMeter || 0;
          const countB = b.data.totalIncomeValueAvgSizeMeter || 0;
          return countB - countA;
        });
      }
      return data;
    },
    getRankCustomer() {
      const data = [];
      let customer = this.dataOccupancy.customerRanking;
      if (customer && customer.length > 0) {
        for (const inx in customer) {
          let c = customer[inx];
          if (c.customer) {
            let firstName = '-';
            if (c.customer.companyName) {
              firstName = c.customer.companyName;
            } else if (c.customer.firstName) {
              firstName = c.customer.firstName;
            }
            let chart = [
              {
                label: [],
                data: [],
                isLineChart: true,
              },
            ];
            for (const key in c.data) {
              let v = c.data[key];
              let totalValue = v.totalValue | 0;
              chart[0].data.push(totalValue);
              chart[0].label.push(key);
            }
            data.push({
              name: firstName,
              objectId: c.customer.objectId,
              totalValue: c.totalValue,
              data: {
                chartData: chart
              }
            })
          }
        }
        this.isActiveCustomer = data[0].objectId || null;
      }
      return data;
    },
    projectById() {
      return this.getByProjectId(this.projectId);
    }
  },
  async created() {
    this.filterOptions.selectMarket = [];
    this.markets = await Market.getMarketByProject(this.projectId)
    if (this.markets) {
      this.filterData.areaMarketIdFirst = this.markets[0].objectId;
      this.filterOptions.selectMarket = this.markets;
      this.project = this.markets[0].project
    }
  },
  async mounted() {
    this.isMountedCheckBarChartOverviewIncome = true;
    this.isMountedCheckPieChart = true,
      this.isMountedCheckBarChartInrent = true;
    this.isMountedCheckDoughnutChartIncome = true;
    this.isMountedCheckPieChartIncome = true;

    if (this.getRankData && this.getRankData[0] && !this.isMarketActive) {
      this.isMarketActive = this.getRankData[0].objectId;
      this.marketName = this.getRankData[0].name;
    }
    this.initNPS();
    this.initData();
  },
  watch: {
    getRankData: {
      handler() {
        this.isMarketActive = this.getRankData[0] ? this.getRankData[0].objectId : null;
        if (this.dataRentalRate) {
          this.dataRentalByMarket = this.getDataRentalRate(this.isMarketActive);
        }
        if (this.dataIncome) {
          this.dataIncomeByMarket = this.getDataIncome(this.isMarketActive)
        }
        this.setProduct({ name: this.getRankData[0].name, objectId: this.getRankData[0].objectId });
      },
      deep: true,
    },
    dataRentalRatePrepare: {
      handler() {
        this.initBarChartRentalRate();
      },
      deep: true,
    },
    dataIncomePrepare: {
      handler() {
        this.initBarChartRentalRate();
      },
      deep: true,
    },
    dataRentalByMarket: {
      handler() {
        this.initBarChartIncome();
      },
      deep: true,
    },
    dataIncomeByMarket: {
      handler() {
        this.initBarChartIncome();
      },
      deep: true,
    },
  },
  methods: {
    initNPS() {
      try {
        if (this.user?.username) {
          let fullName = `${this.user.firstName} ${this.user.lastName}`
          delightedNps.survey({
            name: fullName || "",               // customer name (optional)
            // createdAt: "2016-01-01T12:00:00Z",  // time of initial visit (optional)
            properties: {                       // extra context (optional)
              username: this.user.username,
              optional_email: this.user.email || "", // customer email (optional)
              projectName: this.projectById ? this.projectById.name : "",
              locale: this.user.locale || "th"
            }
          });
        }
      } catch (error) {
        console.log(error)
      }

    },
    async initData() {
      this.isLoading = true;
      try {
        let data = await this.$store.dispatch("overall/getProjectOverAllWithPreviousData", {
          projectId: this.projectId,
          startDate: this.$moment(this.filterData.dateRange.startDate).startOf('day').toDate(),
          endDate: this.$moment(this.filterData.dateRange.endDate).endOf('day').toDate()
        });

        this.summaryStartDate = data.previousData.startDate;
        this.summaryEndDate = data.previousData.endDate;

        this.dataOverAll = data;
        this.initIncome();
        this.initRentalRate();
        this.initAccountingProduct();
        this.initCustomerRanking();
        this.initArea();
        this.initProduct();
        this.isLoading = false;
      } catch (error) {
        console.log(error)
        this.$toast.show({
          content: this.$t('error_in_loading_data'),
          color: "error"
        });
        this.isLoading = false;
      }
    },
    async initRentalRate() {
      this.isLoadingRentalRate = true;
      try {
        this.dataRentalRate = await this.dataOverAll;
        if (this.dataRentalRate) {
          this.setRentalRate();
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
      }
      this.isLoadingRentalRate = false
    },
    setRentalRate() {
      if (this.dataRentalRate) {
        this.marketId = this.filterData.marketId;
        let data = this.getDataRentalRate(this.marketId);
        this.dataRentalRatePrepare = this.prepareDataRentalRate(data);
        if (this.isActiveType === 'rental_rate') {
          this.$nextTick(() => {
            this.initBarChartRentalRate();
          });
        }
        this.summarysData[0] =
        {
          title: this.$t('area.rental_rate'),
          value: this.dataRentalRatePrepare.rentalAreaOccupiedPercent,
          previousValue: this.dataRentalRatePrepare.previousRentalAreaOccupiedPercent,
          currency: 'percent',
          rate: this.dataRentalRatePrepare.totalProfitRentalRate,
          rateType: this.dataRentalRatePrepare.totalProfitRentalRate >= 0 ? 'plus' : 'minus',
          diff: this.dataRentalRatePrepare.growthRate,
          growthRate: this.dataRentalRatePrepare.growthRate,
          type: 'rental_rate',
          chartObj: this.dataRentalRatePrepare.rentalRate,
          startDate: this.summaryStartDate,
          endDate: this.summaryEndDate,
        };
      }
    },
    getDataRentalRate(marketId) {
      let data = {};
      if (this.dataRentalRate) {
        data = {
          rentalAreaOccupiedPercent: 0,
          totalIncomeValue: 0,
          previousRentalAreaOccupiedPercent: 0,
        }
        let rentalRate = this.dataRentalRate.rentalRate
        let previousRentalRate = this.dataRentalRate.previousData.rentalRate
        data.rentalRateTotalMarket = this.dataRentalRate.rentalRate
        if (marketId) {
          let rentalRateMarket = rentalRate.markets[marketId] ? rentalRate.markets[marketId] : null
          let previousRentalRateMarket = previousRentalRate.markets[marketId] ? previousRentalRate.markets[marketId] : null
          data.rentalRate = rentalRateMarket
          data.previousRentalRate = previousRentalRateMarket
          if (this.filterData.type == "show_by_area") {
            data.rentalAreaOccupiedPercent = rentalRateMarket.areaOccupiedPercent || 0;
            data.previousRentalAreaOccupiedPercent = previousRentalRateMarket?.areaOccupiedPercent || 0
          } else {
            data.rentalAreaOccupiedPercent = rentalRateMarket.areaSizeOccupiedPercent || 0
            data.previousRentalAreaOccupiedPercent = previousRentalRateMarket?.areaSizeOccupiedPercent || 0
          }
        } else {
          data.rentalRate = rentalRate.all
          data.previousRentalRate = previousRentalRate.all
          data.rentalAreaOccupiedPercent = this.filterData.type == 'show_by_area' ? this.dataRentalRate.rentalAreaOccupiedPercent : this.dataRentalRate.rentalAreaSizeOccupiedPercent
          data.previousRentalAreaOccupiedPercent = this.filterData.type == 'show_by_area' ? this.dataRentalRate.previousData.rentalAreaOccupiedPercent : this.dataRentalRate.previousData.rentalAreaSizeOccupiedPercent
        }
      }
      return data
    },
    async initIncome() {
      this.isLoadingIncome = true;
      try {
        this.dataIncome = this.dataOverAll;
        this.dataIncomePrevoius = this.dataOverAll;
        if (this.dataIncome && this.dataIncomePrevoius) {
          this.setIncome();
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
      }
      this.isLoadingIncome = false
    },
    setIncome() {
      if (this.dataIncome && this.dataIncomePrevoius) {
        this.marketId = this.filterData.marketId;
        let data = this.getDataIncome(this.marketId);
        this.dataIncomePrepare = this.prepareDataIncome(data);
        if (this.isActiveType === 'total_income') {
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare);
          });
        } else if (this.isActiveType === 'income_per_day') {
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare, 'day');
          });
        } else if (this.isActiveType === 'income_per_area') {
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare, 'area');
          });
        }

        this.summarysData[1] = {
          title: this.$t('payment.all_income'),
          value: this.dataIncomePrepare.totalIncomeValue,
          previousValue: this.dataIncomePrepare.pvTotalIncomeValue,
          currency: 'bath',
          rate: this.$helper.toCurrency(this.dataIncomePrepare.totalProfitIncome),
          rateType: this.dataIncomePrepare.totalProfitIncome >= 0 ? 'plus' : 'minus',
          type: 'total_income',
          chartObj: this.dataIncomePrepare.incomeTotal,
          startDate: this.summaryStartDate,
          endDate: this.summaryEndDate,
        };
        this.summarysData[2] = {
          title: this.$t('income.average_daily_income'),
          value: this.dataIncomePrepare.totalIncomeValueAvgDay,
          previousValue: this.dataIncomePrepare.pvTotalIncomeValueAvgDay,
          currency: 'bath',
          rate: this.$helper.toCurrency(this.dataIncomePrepare.totalProfitIncomeDay),
          rateType: this.dataIncomePrepare.totalProfitIncomeDay >= 0 ? 'plus' : 'minus',
          type: 'income_per_day',
          chartObj: this.dataIncomePrepare.incomeTotal,
          startDate: this.summaryStartDate,
          endDate: this.summaryEndDate,
        };
        this.summarysData[3] = {
          title: this.filterData.type == "show_by_area" ? this.$t('income.average_income_per_stall') : this.$t('income.average_income_per_square_meter'),
          value: this.dataIncomePrepare.totalIncomeValueAvgSize,
          previousValue: this.dataIncomePrepare.pvTotalIncomeValueAvgSize,
          currency: 'bath',
          rate: this.$helper.toCurrency(this.dataIncomePrepare.totalProfitIncomeArea),
          rateType: this.dataIncomePrepare.totalProfitIncomeArea >= 0 ? 'plus' : 'minus',
          type: 'income_per_area',
          chartObj: this.dataIncomePrepare.incomeAreaAvg,
          startDate: this.summaryStartDate,
          endDate: this.summaryEndDate,
        };
      }
    },
    getDataIncome(marketId) {
      let data = {};
      if (this.dataIncome && this.dataIncomePrevoius) {
        data = {
          totalIncomeValue: 0,
          totalIncomeValueAvgDay: 0,
          totalIncomeValueAvgSize: 0,
          pvTotalIncomeValue: 0,
          pvTotalIncomeValueAvgDay: 0,
          pvTotalIncomeValueAvgSize: 0,
          totalIncomeValueAvgSizeMeter: 0,
        }
        let income = this.dataIncome.income
        data.incomeTotalMarket = this.dataIncome.income.totalMarket
        let pvIncome = this.dataIncomePrevoius.previousData.income
        data.pvIncomeTotalMarket = this.dataIncomePrevoius.previousData.income.totalMarket

        if (marketId) {
          let incomeMarket = income.totalMarket[marketId] ? income.totalMarket[marketId] : null
          let pvIncomeMarket = pvIncome.totalMarket[marketId] ? pvIncome.totalMarket[marketId] : null
          data.income = income.markets[marketId]
          data.pvIncome = pvIncome.markets[marketId]
          data.totalIncomeValue = incomeMarket.totalValue || 0
          data.totalIncomeValueAvgDay = incomeMarket.totalIncomeValueAvgDay || 0
          data.totalIncomeValueAvgSizeMeter = incomeMarket.totalValueAvgSize || 0
          // Prevoius
          data.pvTotalIncomeValue = pvIncomeMarket.totalValue || 0
          data.pvTotalIncomeValueAvgDay = pvIncomeMarket.totalIncomeValueAvgDay || 0
          if (this.filterData.type == "show_by_area") {
            data.totalIncomeValueAvgSize = incomeMarket.totalValueAvgCount || 0
            data.pvTotalIncomeValueAvgSize = pvIncomeMarket.totalValueAvgCount || 0
          } else {
            data.totalIncomeValueAvgSize = incomeMarket.totalValueAvgSize || 0
            data.pvTotalIncomeValueAvgSize = pvIncomeMarket.totalValueAvgSize || 0
          }
        } else {
          data.income = income.all
          data.pvIncome = pvIncome.all
          data.totalIncomeValue = this.dataIncome.totalIncomeValue || 0
          data.totalIncomeValueAvgDay = this.dataIncome.totalIncomeValueAvgDay || 0

          data.pvTotalIncomeValue = this.dataIncomePrevoius.previousData.totalIncomeValue || 0
          data.pvTotalIncomeValueAvgDay = this.dataIncomePrevoius.previousData.totalIncomeValueAvgDay || 0
          if (this.filterData.type == "show_by_area") {
            data.totalIncomeValueAvgSize = this.dataIncome.totalIncomeValueAvgCount || 0
            data.pvTotalIncomeValueAvgSize = this.dataIncomePrevoius.previousData.totalIncomeValueAvgCount || 0
          } else {
            data.totalIncomeValueAvgSize = this.dataIncome.totalIncomeValueAvgSize || 0
            data.pvTotalIncomeValueAvgSize = this.dataIncomePrevoius.previousData.totalIncomeValueAvgSize || 0
          }
        }
      }
      return data
    },
    async initAccountingProduct() {
      this.isLoadingAccountingProduct = true;
      try {
        this.dataAccountingProduct = this.dataOverAll.accountingProduct;
        if (this.dataAccountingProduct) {
          this.setAccountiongProduct();
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
      }
      this.isLoadingAccountingProduct = false
    },
    setAccountiongProduct() {
      if (this.dataAccountingProduct) {
        this.marketId = this.filterData.marketId;
        this.dataAccountingProductPrepare = this.getDataAccountingProduct(this.marketId);
        if (this.isActiveType === 'total_income') {
          this.$nextTick(() => {
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        } else if (this.isActiveType === 'income_per_day') {
          this.$nextTick(() => {
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        } else if (this.isActiveType === 'income_per_area') {
          this.$nextTick(() => {
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        }
      }
    },
    getDataAccountingProduct(marketId) {
      let data = {};
      if (this.dataAccountingProduct) {
        let accountingProduct = this.dataAccountingProduct
        if (marketId) {
          data.accountingProduct = accountingProduct.markets[marketId]
        } else {
          data.accountingProduct = accountingProduct.all
        }
      }
      return data
    },
    async initProduct(val) {
      this.isLoadingProduct = true;
      try {
        this.dataProduct = await this.dataOverAll.product;
        if (this.dataProduct) {
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
      }
      this.isLoadingProduct = false
    },
    setProduct(val) {
      if (this.dataProduct) {
        this.marketId = this.filterData.marketId;
        if (val) {
          this.marketId = val.objectId;
          this.marketName = val.name ? val.name : '-';
          let data = null;
          if (this.getRankData && !this.isMarketActive) {
            this.isMarketActive = this.getRankData[0].objectId;
            data = this.getDataProduct(this.isMarketActive)
          } else {
            this.isMarketActive = this.marketId;
          }
          data = this.getDataProduct(this.marketId)
          this.dataProductPrepare = data;
          this.initPieChartProductCategorys(this.dataProductPrepare);
        }
      }
    },
    getDataProduct(marketId) {
      let data = {};
      if (this.dataProduct) {
        let product = this.dataProduct
        if (marketId) {
          data.product = product.markets[marketId]
        } else {
          data.product = product.all
        }
      }
      return data
    },
    async initCustomerRanking() {
      this.isLoadingCustomerRanking = true;
      try {
        this.customerRanking = this.dataOverAll.customerRanking;
        this.customer = [];
        let customer = this.customerRanking;
        if (this.customerRanking) {
          for (const inx in customer) {
            let c = customer[inx];
            if (c.name) {
              // let firstName = '-';
              // if(c.customer.companyName){
              //   firstName = c.customer.companyName;
              // }else if(c.customer.firstName){
              //   firstName = c.customer.firstName;
              // }
              let chart = [
                {
                  label: [],
                  data: [],
                  isLineChart: true,
                },
              ];
              for (const key in c.data) {
                let v = c.data[key];
                let totalValue = v.totalValue | 0;
                chart[0].data.push(totalValue);
                chart[0].label.push(key);
              }
              this.customer.push({
                name: c.name,
                objectId: c.name,
                totalValue: c.totalValue,
                data: {
                  chartData: chart
                }
              })
            }
          }
          if (this.customer && this.customer.length > 0) {
            this.isActiveCustomer = this.customer[0].objectId || null;
          }
        }
      } catch (err) {
        console.log(err)
      }
      this.isLoadingCustomerRanking = false
    },
    async initArea() {
      this.isLoadArea = true;
      try {
        this.dataArea = this.dataOverAll.area;
      } catch (err) {
        console.log(err)
      }
      this.isLoadArea = false
    },
    initMarketChart(val) {
      if (val) {
        this.marketId = val.objectId;
        this.marketName = val.name ? val.name : '-';
        let dataProduct = null;
        this.dataBarChartIncome = null;
        if (this.getRankData && !this.isMarketActive) {
          this.isMarketActive = this.getRankData[0].objectId;
          dataProduct = this.getDataProduct(this.isMarketActive)
          this.dataIncomeByMarket = this.getDataIncome(this.isMarketActive)
          this.dataRentalByMarket = this.getDataRentalRate(this.isMarketActive)
        } else {
          this.isMarketActive = this.marketId;
        }
        dataProduct = this.getDataProduct(this.marketId)
        this.dataIncomeByMarket = this.getDataIncome(this.marketId)
        this.dataRentalByMarket = this.getDataRentalRate(this.marketId)

        this.initBarChartIncome();
        this.initPieChartProductCategorys(dataProduct);
      }
      return false;
    },
    initBarChartRentalRate() {
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 13,
                weight: "bold"
              },
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              color: function (context) {
                let color = "#00000099";
                if (context.datasetIndex == 0) {
                  color = `#C0C0C0`;
                } else if (context.datasetIndex == 1) {
                  color = `#4CAF50`;
                }
                return color;
              },
              formatter: (data) => `${parseFloat(data.x).toFixed(2)}%`,
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipRentalRate,
            },
          },
          scales: {
            y: {
              ticks: {
                callback: function (val) {
                  return (
                    parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "%"
                  );
                }
              }
            },
          },
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-bar-legend');
              if (legendContainer) {
                legendContainer.innerHTML = '';
                chart.data.datasets.forEach((dataset, index) => {
                  const legendItem = document.createElement('span');
                  legendItem.classList.add('chart-legend-box');
                  legendItem.innerHTML = `
                  <span class="chart-legend-color" style="background-color:${dataset.backgroundColor};"></span>
                  <span class="chart-legend-text">${dataset.label}</span>
                `;
                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(index);
                    meta.hidden = !meta.hidden;
                    chart.update();
                    if (meta.hidden) {
                      legendItem.querySelector('.chart-legend-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.chart-legend-text').style.textDecoration = 'none';
                    }
                  });
                  const meta = chart.getDatasetMeta(index);
                  if (meta.hidden) {
                    legendItem.querySelector('.chart-legend-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              }
            }
          },
          {
            id: "legendMargin",
            beforeInit: function (chart, options) {
              const fitValue = chart.legend.fit;
              chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 50);
              };
            }
          }
        ]
      };
      dataChart.data.datasets = [
        {
          label: this.$t('area.previous_year_rental_rate'),
          type: "bar",
          data: [],
          backgroundColor: "#C0C0C0",
          borderRadius: 5,
        },
        {
          label: this.$t('area.rental_rate'),
          type: "bar",
          data: [],
          backgroundColor: "#4CAF50",
          borderRadius: 5,
        },
      ];

      let dataRental = this.dataRentalRatePrepare;
      let dataIncomes = this.dataIncomePrepare;
      const dataKeyPreviousRental = dataRental ? Object.keys(dataRental.previousRentalRateData) : [];
      const dataKeysIncome = dataIncomes ? Object.keys(dataIncomes.incomesData) : [];


      for (let i = 0; i < dataKeyPreviousRental.length; i++) {
        const index = dataKeyPreviousRental[i];
        let dataPreviouseRentalRate = dataRental.previousRentalRateData[index];
        let areaValue = this.filterData.type === 'show_by_area'
          ? dataPreviouseRentalRate.areaOccupiedPercent
          : dataPreviouseRentalRate.areaSizeOccupiedPercent;
        dataChart.data.datasets[0].data.push({
          x: areaValue > 100 ? 100 : areaValue,
          y: areaValue > 100 ? 100 : areaValue,
          detail: dataPreviouseRentalRate,
          bfDetail: null,
          detailIncome: null,
          bfDetailIncome: null,
          date: index,
        });
        dataChart.data.labels.push(this.$moment(index, "YYYY-MM").subtract(1, 'years').format('MMM'));
      }

      const dataKeyRental = dataRental ? Object.keys(dataRental.rentalRateData) : [];
      for (let i = 0; i < dataKeyRental.length; i++) {
        const index = dataKeyRental[i];
        const indexPrevious = this.$moment(index, "YYYY-MM").subtract(1, 'years').format("YYYY-MM");
        const dataRentalRate = dataRental.rentalRateData[index];
        const dataIncome = dataIncomes ? dataIncomes.incomesData[index] : [];
        let dataPreviouseRentalRate = dataRental.previousRentalRateData[indexPrevious];
        let areaValue = this.filterData.type === 'show_by_area'
          ? dataRentalRate.areaOccupiedPercent
          : dataRentalRate.areaSizeOccupiedPercent;
        let bfDetailIncome = null;
        let bfDetail = null;
        let dateLastYear = null;
        if (dataIncomes) {
          if (i > 0) {
            bfDetailIncome = dataIncomes.incomesData[dataKeysIncome[i - 1]];
          }
        }
        if (dataRental) {
          if (i > 0) {
            bfDetail = dataRental.rentalRateData[dataKeyRental[i - 1]];
          }
        }
        dataChart.data.datasets[1].data.push({
          x: areaValue > 100 ? 100 : areaValue,
          y: areaValue > 100 ? 100 : areaValue,
          detail: dataRentalRate,
          bfDetail: bfDetail,
          detailIncome: dataIncome,
          bfDetailIncome: bfDetailIncome,
          detailPreviouseRental: dataPreviouseRentalRate,
          date: index,
          dateLastYear: dateLastYear
        });
      }

      if (!this.barChart || this.isMountedCheckBarChartInrent) {
        const ctx = document.getElementById("bar-chart");
        if (ctx) {
          this.barChart = new Chart(ctx, dataChart);
        }
        this.isMountedCheckBarChartInrent = false;
      } else {
        this.barChart.data.labels = dataChart.data.labels;
        this.barChart.data.datasets[0].data = dataChart.data.datasets[0].data;
        this.barChart.data.datasets[1].data = dataChart.data.datasets[1].data;
        this.barChart.update();
      }
    },
    initBarChartIncome() {
      let dataChart = {
        type: "bar",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              ticks: {
                callback: function (value, index, ticks) {
                  let SI_SYMBOL = ["", "K", "M", "B", "T", "P", "E"];
                  let tier = (Math.log10(Math.abs(value.x)) / 3) | 0;
                  if (tier == 0) return value;
                  let suffix = SI_SYMBOL[tier];
                  let scale = Math.pow(10, tier * 3);
                  let scaled = value / scale;
                  return scaled.toFixed(1) + suffix;
                }
              }
            },
            y1: {
              display: true,
              type: "linear",
              position: "right",
              beginAtZero: true
            }
          },
          plugins: {
            legend: {
              display: false,
              position: "top",
              align: "end",
              labels: {
                boxWidth: 20,
                color: "#111",
                padding: 15
              }
            },
            labels: {
              render: "value"
            },
            title: {
              text: "",
              display: false
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipIncome
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 12,
                weight: "bold"
              },
              yPadding: 8,
              textAlign: "center",
              textStrokeColor: "#FFFFFF50",
              textStrokeWidth: 1,
              color: function (context) {
                let color = "##FFAB6C";
                if (context.datasetIndex == 0) {
                  color = `#285CA4`;
                } else if (context.datasetIndex == 1) {
                  color = `#FFAB6C`;
                }
                return color;
              },
              formatter: (val, context) => {
                let text;
                if (context.datasetIndex == 0) {
                  text = this.$helper.toCurrency(parseFloat(val.x || 0).toFixed(2), null, { isAbbreviate: true, isPrefixSign: true });
                } else if (context.datasetIndex == 1) {
                  text = this.$helper.toCurrency(parseFloat(val || 0).toFixed(2), null, { isAbbreviate: true, isPrefixSign: true });
                }
                return text;
              },
              offset: function (context) {
                return context.datasetIndex === 0 ? -10 : 25;
              },
              rotation: -45,
            }
          },
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-legend');
              legendContainer.innerHTML = '';
              chart.data.datasets.forEach((dataset, index) => {
                const legendItem = document.createElement('span');
                legendItem.classList.add('chart-legend-box');
                legendItem.innerHTML = `
                  <span class="chart-legend-color" style="background-color:${dataset.backgroundColor};"></span>
                  <span class="chart-legend-text">${dataset.label}</span>
                `;
                legendItem.addEventListener('click', () => {
                  const meta = chart.getDatasetMeta(index);
                  meta.hidden = !meta.hidden;
                  chart.update();
                  if (meta.hidden) {
                    legendItem.querySelector('.chart-legend-text').style.textDecoration = 'line-through';
                  } else {
                    legendItem.querySelector('.chart-legend-text').style.textDecoration = 'none';
                  }
                });
                const meta = chart.getDatasetMeta(index);
                if (meta.hidden) {
                  legendItem.querySelector('.chart-legend-text').style.textDecoration = 'line-through';
                }
                legendContainer.appendChild(legendItem);
              });
            }
          },
          {
            id: "legendMargin",
            beforeInit: function (chart, options) {
              const fitValue = chart.legend.fit;
              chart.legend.fit = function fit() {
                fitValue.bind(chart.legend)();
                return (this.height += 60);
              };
            }
          }
        ]
      };

      if (this.dataRentalByMarket) {
        dataChart.data.labels = [];
        dataChart.data.datasets[0] = {
          label: this.$t('income.title'),
          type: "bar",
          data: [],
          backgroundColor: ["#285CA4"],
          borderColor: ["#285CA4"],
          borderWidth: 1,
          order: 1,
          borderRadius: 5,
        };
        dataChart.data.datasets[1] = {
          label: this.$t('area.average_renter'),
          type: "line",
          data: [],
          backgroundColor: "#FFAB6C",
          borderColor: "#FFAB6C",
          tension: 0.3,
          fill: false,
          yAxisID: "y1",
          order: 0
        };

        let dataIncomes = this.dataIncomeByMarket ? this.dataIncomeByMarket : null;
        let objRentalRate = this.dataRentalByMarket ? this.dataRentalByMarket : null;
        const dataKeys = dataIncomes ? Object.keys(dataIncomes.income) : [];
        const rentalRateKeys = objRentalRate ? Object.keys(objRentalRate.rentalRate) : [];
        if (dataKeys.length > 0 && rentalRateKeys.length > 0) {
          for (let i = 0; i < dataKeys.length; i++) {
            const index = dataKeys[i];
            const indexRental = rentalRateKeys[i];
            const dataIncome = dataIncomes ? dataIncomes.income[index] : [];
            const dataRentalRate = objRentalRate ? objRentalRate.rentalRate[indexRental] : [];
            const areaCount = dataIncome && dataIncome.areaCount ? dataIncome.areaCount : 0;
            const totalValue = dataIncome && dataIncome.totalValue ? dataIncome.totalValue : 0;
            const areaOccupied = dataRentalRate && dataRentalRate.areaOccupied ? dataRentalRate.areaOccupied : 0;
            let previousIncome = dataIncomes && i > 0 ? dataIncomes.income[dataKeys[i - 1]] : null;
            let previousRentalRate = objRentalRate && i > 0 ? objRentalRate.rentalRate[rentalRateKeys[i - 1]] : null;
            dataChart.data.datasets[0].data.push({
              x: totalValue,
              y: totalValue,
              detail: dataIncome,
              detailRental: dataRentalRate,
              bfDetail: previousIncome,
              bfRentalDetail: previousRentalRate,
              date: index
            });
            dataChart.data.datasets[1].data.push(areaOccupied || 0);
            dataChart.data.labels.push(this.$moment(index, "YYYY-MM").format('MMM'));
          }
        }
      }

      if (!this.barChartOverviewIncome) {
        var ctx = document.getElementById("bar-chart-overview-income");
        if (ctx) {
          this.barChartOverviewIncome = new Chart(ctx, dataChart);
        }
      } else {
        this.barChartOverviewIncome.data = dataChart.data;
        this.barChartOverviewIncome.update();
      }
    },
    initPieChartProductCategorys(dataRes) {
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: {
              top: 100,
            }
          },
          plugins: {
            title: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipProductCategory
            },
            datalabels: {
              align: "top",
              anchor: "end",
              font: {
                size: 13,
                weight: "bold"
              },
              display: false,
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: function (data, ctx) {
                return (
                  ctx.chart.data.labels[ctx.dataIndex] + " " + data.value + "%"
                );
              },
              offset: 20,
            },
          },
          responsive: true,
          onClick: (evt, activeElements) => {
            if (activeElements.length > 0) {
              const index = activeElements[0].index;
              this.typeChartDialog = "product_type_proportion";
              this.dataModalPrepare = dataChart.data.datasets[0].data[index].detail;
              this.isOccRateDialog = true;
            }
          }
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-pie-legend');
              legendContainer.innerHTML = '';

              chart.data.datasets.forEach((dataset, datasetIndex) => {
                dataset.data.forEach((data, index) => {
                  const legendItem = document.createElement('div');
                  legendItem.classList.add('product-type-box');
                  const label = chart.data.labels[index];
                  const bgColor = dataset.backgroundColor[index];

                  legendItem.innerHTML = `
                    <div class="product-type-color" style="background-color:${bgColor};"></div>
                    <div class="product-type-text">${label}</div>
                  `;

                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const sliceMeta = meta.data[index];
                    sliceMeta.hidden = !sliceMeta.hidden;

                    if (sliceMeta.hidden) {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'none';
                    }

                    chart.update();
                  });
                  const meta = chart.getDatasetMeta(datasetIndex);
                  const sliceMeta = meta.data[index];
                  if (sliceMeta.hidden) {
                    legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              });
            }
          }
        ]
      };
      if (dataRes.product) {
        const colors = this.generateColors(Object.keys(dataRes.product).length);
        dataChart.data.datasets = [
          {
            label: "Product Category",
            data: [],
            backgroundColor: colors,
            borderWidth: 0,
            borderColor: ""
          }
        ];
        const sortedData = [];
        let sum = 0;

        for (const key in dataRes.product) {
          sum += dataRes.product[key].count;
        }

        for (const key in dataRes.product) {
          const data = dataRes.product[key];
          const percent = parseFloat((data.count / sum) * 100).toFixed(2);

          sortedData.push({
            label: data.productCategory.name,
            value: percent,
            id: key,
            detail: data
          });
        }
        sortedData.sort((a, b) => b.value - a.value);
        dataChart.data.labels = sortedData.map(item => item.label);
        dataChart.data.datasets[0].data = sortedData.map((item, inx) => ({
          name: item.label,
          value: item.value,
          id: item.id,
          detail: item.detail,
          rank: inx + 1,
        }));
      }

      if (!this.pieChartProductCategorys || this.isMountedCheckPieChart) {
        let ctx = document.getElementById("pie-chart-product-category");
        if (ctx) this.pieChartProductCategorys = new Chart(ctx, dataChart);
        this.isMountedCheckPieChart = false;
      } else {
        this.pieChartProductCategorys.data = dataChart.data;
        this.pieChartProductCategorys.update();
      }
    },
    initDoughnutChartTotalIncome(dataRes, mode = 'all') {
      let dataChart = {
        type: "doughnut",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: 50,
          },
          plugins: {
            title: {
              display: false,
              text: this.$t('product.product_type_of_market_ratio'),
              position: "top",
              fontSize: 16,
              fontColor: "#111",
              padding: 20
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipDoughnut
            },
            legend: {
              display: false,
              position: "bottom",
              labels: {
                boxWidth: 20,
                fontColor: "#111",
                padding: 15
              }
            },
            datalabels: {
              display: false,
              align: "top",
              anchor: "end",
              font: {
                size: 15,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 3,
              formatter: function (val, ctx) {
                return (
                  ctx.chart.data.labels[ctx.dataIndex] + "\n (" + val.value + "%)"
                );
              }
            }
          },
          responsive: true,
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-total-income-doughnut-legend');
              legendContainer.innerHTML = '';

              chart.data.datasets.forEach((dataset, datasetIndex) => {
                dataset.data.forEach((data, index) => {
                  const legendItem = document.createElement('div');
                  legendItem.classList.add('product-type-box');
                  const label = chart.data.labels[index];
                  const bgColor = dataset.backgroundColor[index];

                  legendItem.innerHTML = `
                    <div class="product-type-color" style="background-color:${bgColor};"></div>
                    <div class="product-type-text">${label}</div>
                  `;

                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const sliceMeta = meta.data[index];
                    sliceMeta.hidden = !sliceMeta.hidden;

                    if (sliceMeta.hidden) {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'none';
                    }

                    chart.update();
                  });
                  const meta = chart.getDatasetMeta(datasetIndex);
                  const sliceMeta = meta.data[index];
                  if (sliceMeta.hidden) {
                    legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              });
            }
          },
        ]
      };
      if (dataRes && dataRes.incomeTotalMarket) {
        const colors = this.generateColors(Object.keys(dataRes.incomeTotalMarket).length);
        dataChart.data.datasets = [
          {
            label: "Product Category",
            data: [],
            backgroundColor: colors,
            borderWidth: 0,
            borderColor: "#ddd"
          }
        ];

        let totalSum = 0;
        for (const key in dataRes.incomeTotalMarket) {
          let data = dataRes.incomeTotalMarket[key];
          let totalValue = 0;
          if (mode == 'all') {
            totalValue = data.totalValue;
          } else if (mode == 'day') {
            totalValue = data.totalIncomeValueAvgDay;
          } else if (mode == 'area') {
            totalValue = data.totalValueAvgSize;
          }
          if (totalValue > 0) {
            totalSum += totalValue;
          }
        }
        const sortedData = [];
        for (const key in dataRes.incomeTotalMarket) {
          let data = dataRes.incomeTotalMarket[key];
          let totalValue = 0;
          if (mode == 'all') {
            totalValue = data.totalValue;
          } else if (mode == 'day') {
            totalValue = data.totalIncomeValueAvgDay;
          } else if (mode == 'area') {
            totalValue = data.totalValueAvgSize;
          }
          if (totalValue > 0) {
            const market = this.markets.find(market => market.objectId === key);
            if (market) {
              const percentage = (totalValue / totalSum) * 100;
              sortedData.push({
                label: market.name,
                percent: parseFloat(percentage.toFixed(2)),
                id: key,
                total: totalValue,
                detail: data,
              });
            }
          }
        }

        sortedData.sort((a, b) => b.percent - a.percent);

        dataChart.data.labels = sortedData.map(item => item.label);
        dataChart.data.datasets[0].data = sortedData.map((item, inx) => ({
          name: item.label,
          value: item.percent,
          id: item.id,
          detail: item.detail,
          total: item.total,
          rank: inx + 1,
        }));
      }


      if (!this.doughnutChartTotalIncome) {
        let ctx = document.getElementById("doughnut-chart-total-income");
        if (ctx) this.doughnutChartTotalIncome = new Chart(ctx, dataChart);
      } else {
        this.doughnutChartTotalIncome.data = dataChart.data;
        this.doughnutChartTotalIncome.update();
      }
    },
    initPieChartTotalIncome(dataRes) {
      let _this = this;
      let dataChart = {
        type: "pie",
        data: {
          labels: [],
          datasets: []
        },
        options: {
          layout: {
            padding: {
              top: 150,
            }
          },
          plugins: {
            title: {
              display: false,
            },
            legend: {
              display: false,
              position: "bottom",
            },
            tooltip: {
              enabled: false,
              external: this.externalTooltipPieIncome,
            },
            datalabels: {
              display: false,
              align: "top",
              anchor: "end",
              font: {
                size: 14,
                weight: "bold"
              },
              color: "#FFFFFF",
              textAlign: "center",
              textStrokeColor: "#00000075",
              textStrokeWidth: 2,
              formatter: function (val, ctx) {
                return (
                  `${ctx.chart.data.labels[ctx.dataIndex]}` + `\n ${this.$t('income.title')} : ${_this.$helper.currencySign()}` + `${parseFloat(val.value || 0)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                );
              }
            }
          },
          responsive: true,
          onClick: (evt, activeElements) => {
            if (activeElements.length > 0) {
              const index = activeElements[0].index;
              this.typeChartDialog = "rent_proportion";
              this.dataModalPrepare = dataChart.data.datasets[0].data[index].info;
              this.isOccRateDialog = true;
            }
          }
        },
        plugins: [
          ChartDataLabels,
          {
            id: "customLegend",
            afterUpdate: function (chart) {
              const legendContainer = document.getElementById('custom-total-income-pie-legend');
              legendContainer.innerHTML = '';

              chart.data.datasets.forEach((dataset, datasetIndex) => {
                dataset.data.forEach((data, index) => {
                  const legendItem = document.createElement('div');
                  legendItem.classList.add('product-type-box');
                  const label = chart.data.labels[index];
                  const bgColor = dataset.backgroundColor[index];

                  legendItem.innerHTML = `
                    <div class="product-type-color" style="background-color:${bgColor};"></div>
                    <div class="product-type-text">${label}</div>
                  `;

                  legendItem.addEventListener('click', () => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const sliceMeta = meta.data[index];
                    sliceMeta.hidden = !sliceMeta.hidden;

                    if (sliceMeta.hidden) {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                    } else {
                      legendItem.querySelector('.product-type-text').style.textDecoration = 'none';
                    }

                    chart.update();
                  });
                  const meta = chart.getDatasetMeta(datasetIndex);
                  const sliceMeta = meta.data[index];
                  if (sliceMeta.hidden) {
                    legendItem.querySelector('.product-type-text').style.textDecoration = 'line-through';
                  }
                  legendContainer.appendChild(legendItem);
                });
              });
            }
          }
        ]
      };

      dataChart.data.datasets = [
        {
          label: "Product Category",
          data: [],
          backgroundColor: [],
          borderWidth: 0,
          borderColor: "#ddd"
        }
      ];

      let sum = 0;
      for (const key in dataRes.accountingProduct) {
        sum += dataRes.accountingProduct[key].totalValue;
      }

      for (const key in dataRes.accountingProduct) {
        let data = dataRes.accountingProduct[key];
        const percent = parseFloat((data.totalValue / sum) * 100).toFixed(2);
        let name = "";
        if (key == "facility") {
          name = this.$t('project.public_facility');
          dataChart.data.datasets[0].backgroundColor.push("#285CA4");
        } else if (key == "rental") {
          name = this.$t('rental_rate');
          dataChart.data.datasets[0].backgroundColor.push("#4CAF50");
        } else if (key == "service") {
          name = this.$t('service');
          dataChart.data.datasets[0].backgroundColor.push("#0A5022");
        } else if (key == "penalty") {
          name = this.$t('penalty.title');
          dataChart.data.datasets[0].backgroundColor.push("#544CAF");
        } else if (key == "deposit") {
          name = this.$t('deposit');
          dataChart.data.datasets[0].backgroundColor.push("#E47D32");
        } else if (key == "discount") {
          name = this.$t('discount');
          dataChart.data.datasets[0].backgroundColor.push("#72ABF6");
        }
        data.name = name;
        if (data.totalValue > 0) {
          dataChart.data.labels.push(name);
          dataChart.data.datasets[0].data.push({
            name: name,
            value: data.totalValue,
            id: key,
            info: data,
            percent: percent,
          });
        }
      }
      if (!this.pieChartTotalIncome) {
        let ctx = document.getElementById("pie-chart-total-income");
        if (ctx) this.pieChartTotalIncome = new Chart(ctx, dataChart);
      } else {
        this.pieChartTotalIncome.data = dataChart.data;
        this.pieChartTotalIncome.update();
      }
    },
    prepareDataRentalRate(dataRentalRate) {
      let dataRes = {
        rentalRate: {
          chartData: [
            {
              label: [],
              data: [],
              areaCount: [],
              value: null,
              isLineChart: false,
            },
            {
              label: [],
              data: [],
              areaCount: [],
              value: null,
              isLineChart: true,
            },
          ],
        },
        previousRentalRateData: [],
        rentalRateData: [],
        rentalAreaOccupiedPercent: 0,
        totalProfitRentalRate: 0,
        growthRate: 0,
        firstOccupancy: 0,
        lastOccupancy: 0,
        previousRentalAreaOccupiedPercent: 0,
      };
      if (dataRentalRate) {

        // Calculate Profit
        if (dataRentalRate.rentalRate) {
          dataRes.rentalAreaOccupiedPercent = dataRentalRate.rentalAreaOccupiedPercent;
          dataRes.previousRentalAreaOccupiedPercent = dataRentalRate.previousRentalAreaOccupiedPercent;

          let currentPercent = parseFloat(dataRentalRate.rentalAreaOccupiedPercent || 0);
          let prevoiusPrecent = parseFloat(dataRentalRate.previousRentalAreaOccupiedPercent || 0);

          const profitPercentage = (currentPercent - prevoiusPrecent)
          if (!isNaN(profitPercentage) && profitPercentage !== Infinity && profitPercentage !== -Infinity) {
            dataRes.totalProfitRentalRate = `${profitPercentage.toFixed(2)}`
          } else {
            dataRes.totalProfitRentalRate = 0.00;
          }

          let growthRate = (profitPercentage / prevoiusPrecent * 100)
          if (!isNaN(growthRate) && growthRate !== Infinity && growthRate !== -Infinity) {
            dataRes.growthRate = growthRate.toFixed(2)
          } else {
            dataRes.growthRate = 0.00;
          }
        }
        // previousRentalRate
        const previousRentalRate = dataRentalRate.previousRentalRate
        const rentalRate = dataRentalRate.rentalRate
        for (const index in previousRentalRate) {
          let dataPreviouseRentalRate = previousRentalRate[index];
          if (this.filterData.type == 'show_by_area') {
            dataRes.rentalRate.chartData[0].value = dataPreviouseRentalRate.areaOccupiedPercent;
          } else {
            dataRes.rentalRate.chartData[0].value = dataPreviouseRentalRate.areaSizeOccupiedPercent;
          }
          dataRes.rentalRate.chartData[0].areaCount = dataPreviouseRentalRate.areaCount;
          dataRes.rentalRate.chartData[0].data.push(dataRes.rentalRate.chartData[0].value || 0)
          dataRes.rentalRate.chartData[0].label.push(this.$moment(index, "YYYY-MM").subtract(1, 'years').format('MMM'))
        }
        // // rentalRate
        for (const index in rentalRate) {
          let dataRentalRate = rentalRate[index];
          if (this.filterData.type == 'show_by_area') {
            dataRes.rentalRate.chartData[1].value = dataRentalRate.areaOccupiedPercent;
          } else {
            dataRes.rentalRate.chartData[1].value = dataRentalRate.areaSizeOccupiedPercent;
          }
          dataRes.rentalRate.chartData[1].areaCount = dataRentalRate.areaCount;
          dataRes.rentalRate.chartData[1].data.push(dataRes.rentalRate.chartData[1].value || 0)
          dataRes.rentalRate.chartData[1].label.push(this.$moment(index, "YYYY-MM").subtract(1, 'years').format('MMM'))
        }
        dataRes.previousRentalRateData = dataRentalRate.previousRentalRate;
        dataRes.rentalRateData = dataRentalRate.rentalRate;
      }
      return dataRes;
    },
    prepareDataIncome(dataIncome) {
      let dataRes = {
        incomeTotal: {
          chartData: [
            {
              label: [],
              data: [],
              areaCount: [],
              value: null,
              isLineChart: true,
            },
          ],
        },
        incomeDayAvg: {
          chartData: [
            {
              label: [],
              data: [],
              areaCount: [],
              value: null,
              isLineChart: true,
            },
          ],
        },
        incomeAreaAvg: {
          chartData: [
            {
              label: [],
              data: [],
              areaCount: [],
              value: null,
              isLineChart: true,
            },
          ],
        },
        incomesData: [],
        incomesDataPrevious: [],
        incomeTotalMarket: [],
        totalIncomeValue: 0,
        totalIncomeValueAvgDay: 0,
        totalIncomeValueAvgSize: 0,

        pvTotalIncomeValue: 0,
        pvTotalIncomeValueAvgDay: 0,
        pvTotalIncomeValueAvgSize: 0,

        totalIncomeValueMarket: 0,
        totalProfitIncome: 0,
        totalProfitIncomeDay: 0,
        totalProfitIncomeArea: 0,
        firstOccupancy: 0,
        lastOccupancy: 0,
      };
      if (dataIncome) {
        if (dataIncome.income) {

          dataRes.totalIncomeValue = dataIncome.totalIncomeValue;
          dataRes.totalIncomeValueAvgDay = dataIncome.totalIncomeValueAvgDay;
          dataRes.totalIncomeValueAvgSize = dataIncome.totalIncomeValueAvgSize;

          dataRes.pvTotalIncomeValue = dataIncome.pvTotalIncomeValue;
          dataRes.pvTotalIncomeValueAvgDay = dataIncome.pvTotalIncomeValueAvgDay;
          dataRes.pvTotalIncomeValueAvgSize = dataIncome.pvTotalIncomeValueAvgSize;

          let currentPercent = parseFloat(dataIncome.totalIncomeValue || 0);
          let prevoiusPercent = parseFloat(dataIncome.pvTotalIncomeValue || 0);

          const profitPercentage = ((currentPercent - prevoiusPercent) / prevoiusPercent) * 100;
          if (!isNaN(profitPercentage) && profitPercentage !== Infinity && profitPercentage !== -Infinity) {
            dataRes.totalProfitIncome = `${profitPercentage.toFixed(2)}`
          } else {
            dataRes.totalProfitIncome = 0.00;
          }

          let currentPercentDay = parseFloat(dataIncome.totalIncomeValueAvgDay || 0);
          let prevoiusPercentDay = parseFloat(dataIncome.pvTotalIncomeValueAvgDay || 0);
          const profitPercentageDay = ((currentPercentDay - prevoiusPercentDay) / prevoiusPercentDay) * 100;
          if (!isNaN(profitPercentageDay) && profitPercentageDay !== Infinity && profitPercentageDay !== -Infinity) {
            dataRes.totalProfitIncomeDay = `${profitPercentageDay.toFixed(2)}`
          } else {
            dataRes.totalProfitIncomeDay = 0.00;
          }

          let currentPercentArea = parseFloat(dataIncome.totalIncomeValueAvgSize || 0);
          let prevoiusPercentArea = parseFloat(dataIncome.pvTotalIncomeValueAvgSize || 0);
          const profitPercentageArea = ((currentPercentArea - prevoiusPercentArea) / prevoiusPercentArea) * 100;
          if (!isNaN(profitPercentageArea) && profitPercentageArea !== Infinity && profitPercentageArea !== -Infinity) {
            dataRes.totalProfitIncomeArea = `${profitPercentageArea.toFixed(2)}`
          } else {
            dataRes.totalProfitIncomeArea = 0.00;
          }
        }

        const incomes = dataIncome.income
        for (const index in incomes) {
          let dataIncome = incomes[index];
          let areaCount = dataIncome.areaCount;
          let areaSizeCount = dataIncome.areaSizeCount;
          let totalValue = dataIncome.totalValue;
          let totalValueAvgSize = dataIncome.totalValueAvgSize;
          dataRes.incomeTotal.chartData[0].value = totalValue;
          dataRes.incomeTotal.chartData[0].data.push(totalValue || 0)
          dataRes.incomeTotal.chartData[0].label.push(this.$moment(index, "YYYY-MM").format('MMM'))

          dataRes.incomeAreaAvg.chartData[0].value = totalValueAvgSize;
          dataRes.incomeAreaAvg.chartData[0].data.push(totalValueAvgSize || 0)
          dataRes.incomeAreaAvg.chartData[0].label.push(this.$moment(index, "YYYY-MM").format('MMM'))
        }
        dataRes.incomesData = dataIncome.income;
        dataRes.incomesDataPrevious = dataIncome.pvIncome;
        dataRes.incomeTotalMarket = dataIncome.incomeTotalMarket;
      }
      return dataRes;
    },
    getChartType(val) {
      if (this.isActiveType !== val.type) {
        this.resetChart();
        this.isActiveType = val.type;
        if (this.isActiveType === 'rental_rate') {
          this.$nextTick(() => {
            this.initBarChartRentalRate();
          });
        } else if (this.isActiveType === 'total_income') {
          this.textTitleMainChart = this.$t('payment.all_income')
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare);
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        } else if (this.isActiveType === 'income_per_day') {
          this.textTitleMainChart = this.$t('income.average_daily_income')
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare, 'day');
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        } else if (this.isActiveType === 'income_per_area') {
          this.textTitleMainChart = this.filterData.type == "show_by_area" ? this.$t('income.average_income_per_stall') : this.$t('income.average_income_per_square_meter')
          this.$nextTick(() => {
            this.initDoughnutChartTotalIncome(this.dataIncomePrepare, 'area');
            this.initPieChartTotalIncome(this.dataAccountingProductPrepare);
          });
        }
      }
    },
    changeRankType(e) {
      if (this.filterData.rankType == 'total_income') {
        this.colorLineChart = ['rgba(76, 175, 80, 1)', 'rgba(76, 175, 80, 0)'];
      } else if (this.filterData.rankType == 'income_meters') {
        this.colorLineChart = ['rgba(40, 91, 162, 1)', 'rgba(40, 91, 162, 0.12)'];
      } else if (this.filterData.rankType == 'top_traders') {
        this.colorLineChart = ['rgba(228, 125, 50, 1)', 'rgba(228, 125, 50, 0.12)'];
      } else {
        this.colorLineChart = ['rgba(229, 229, 239, 1)', 'rgba(229, 229, 239, 0.2)'];
      }
    },
    async onChangeMarket() {
      this.isSearching = true;
      try {
        if (this.isActiveType === 'income_per_area') {
          this.textTitleMainChart = this.filterData.type == "show_by_area" ? this.$t('income.average_income_per_stall') : this.$t('income.average_income_per_square_meter')
        }
        this.resetChart();
        this.setRentalRate();
        this.setIncome();
        this.setAccountiongProduct();

        let market = this.markets.find((item) => item.objectId == this.filterData.marketId);
        if (market) {
          this.initMarketChart(market);
        } else {
          this.initMarketChart(this.getRankData[0]);
        }
        this.isSearching = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isSearching = false;
      }
    },
    changeMarketArea() {
      this.isLoadArea = true;
      setTimeout(() => {
        this.isLoadArea = false;
      }, 200);
    },
    async onSearch() {
      this.isSearching = true;
      try {
        this.resetChart();
        this.initData();
        this.isSearching = false;
      } catch (error) {
        console.log(error);
        if (error?.response?.data?.error) {
          this.errorMsg = error.response.data.error;
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        this.isSearching = false;
      }
    },
    resetChart() {
      if (this.barChart) {
        this.barChart.destroy();
        this.barChart = null;
      }
      if (this.doughnutChartTotalIncome) {
        this.doughnutChartTotalIncome.destroy();
        this.doughnutChartTotalIncome = null;
      }
      if (this.pieChartTotalIncome) {
        this.pieChartTotalIncome.destroy();
        this.pieChartTotalIncome = null;
      }
    },
    externalTooltipRentalRate(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-rental-rate');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-rental-rate';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.box-chart-rental');
        chartContainer.appendChild(tooltipEl);
      }

      const tooltipModel = context.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }

      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const bodyLines = [
          `
          <div style="font-size:14px !important">${this.$t('month')} ${this.$moment(data.date, "YYYY-MM").format('MMMM YYYY')}</div>
          <div class="divider-solid"></div>
          <div class="d-flex justify-between">
            <div style="text-align: left;">
               ${this.$t('area.rental_rate')}
            </div>
            <div style="text-align: right;">
            ${this.$helper.toCurrency(parseFloat(data.x || 0))} %
            </div>
          </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('area.stall_rented')}
            </div>
            <div style="text-align: right;">
              ${parseFloat(data.detail.areaOccupied || 0).toFixed(2)} ${this.$t('area.space')}
            </div>
          </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('area.all_stall')}
            </div>
            <div style="text-align: right;">
              ${parseFloat(data.detail.areaCount || 0).toFixed(2)} ${this.$t('area.space')}
            </div>
          </div>`,
        ];

        if (data.bfDetailIncome && this.isLoadingIncome) {
          bodyLines.push(`<div>Loading...</div>`)
        }
        if (!this.isLoadingIncome && context.tooltip.dataPoints[0].datasetIndex == 1) {
          let bfIncome = data.bfDetailIncome ? parseFloat(data.detailIncome.totalValue - (data.bfDetailIncome ? data.bfDetailIncome.totalValue : 0)) : null;
          let bfRentalPercent = 0;
          let bfRentalPercentYear = 0;
          let date = this.$moment(data.date, "YYYY-MM").subtract(1, 'years').format('MMMM YYYY')
          if (this.filterData.type === 'show_by_area') {
            bfRentalPercent = data.bfDetail ? parseFloat(data.detail.areaOccupiedPercent - (data.bfDetail ? data.bfDetail.areaOccupiedPercent : 0)) : null;
            bfRentalPercentYear = data.detailPreviouseRental ? parseFloat(data.detail.areaOccupiedPercent - data.detailPreviouseRental.areaOccupiedPercent).toFixed(2) : null;
          } else {
            bfRentalPercent = data.bfDetail ? parseFloat(data.detail.areaSizeOccupiedPercent - (data.bfDetail ? data.bfDetail.areaSizeOccupiedPercent : 0)) : null;
            bfRentalPercentYear = data.detailPreviouseRental ? parseFloat(data.detail.areaSizeOccupiedPercent - data.detailPreviouseRental.areaSizeOccupiedPercent).toFixed(2) : null;
          }

          bodyLines.push(
            `<div class="divider-dashed"></div>
              <div class="d-flex justify-between">
                <div style="text-align: left;">${this.$t('income.income_from_month', { data: this.$moment(data.date, "YYYY-MM").format('MMMM YYYY') })} </div>
                <div style="text-align: right;color:${this.getColorCurrency(data.detailIncome.totalValue)};">
                 ${this.$helper.toCurrency(data.detailIncome.totalValue, null, { isSuffixSign: true })} 
              </div>
            </div>`
          );

          if (data.dateLastYear) {
            date = this.$moment(data.dateLastYear, "YYYY-MM").format('MMMM YYYY')
          }

          bodyLines.push(
            `
          <div class="d-flex justify-between">
            <div style="text-align: left;">${this.$t('income.difference_income_from_previous_month')}</div>
            <div style="text-align: right;color:${this.getColorCurrency(bfIncome)};">
              ${this.getTextCurrency(bfIncome, 'bath')} 
            </div>
          </div>`,
            `
          <div class="d-flex justify-between">
            <div style="text-align: left;">${this.$t('area.difference_rental_rate_from_previous_month')}</div>
            <div style="text-align: right;color:${this.getColorCurrency(bfRentalPercent)};">
              ${this.getTextCurrency(bfRentalPercent, 'percent')}
            </div>
          </div>`,
            `
          <div class="d-flex justify-between">
            <div style="text-align: left;">${this.$t('area.difference_rental_rate_from_month', { data: date })}</div>
            <div style="text-align: right;color:${this.getColorCurrency(bfRentalPercentYear)};">
              ${this.getTextCurrency(bfRentalPercentYear, 'percent')}
            </div>
          </div>`,
          );
        }
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;
      }

      let left = tooltipModel.caretX;
      let top = tooltipModel.caretY;
      tooltipEl.style.opacity = 1;
      tooltipEl.style.visibility = 'visible';
      tooltipEl.style.position = 'absolute';

      const tooltipWidth = tooltipEl.offsetWidth;
      const chartContainer = document.querySelector('.box-chart-rental');
      const chartWidth = chartContainer.clientWidth;

      if (left + tooltipWidth > chartWidth) {
        left = chartWidth - tooltipWidth - 10;
      }

      tooltipEl.style.left = `${left}px`;
      tooltipEl.style.top = `${top}px`;
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
      tooltipEl.style.color = 'white';
      tooltipEl.style.borderRadius = '5px';
      tooltipEl.style.padding = '10px';
    },
    externalTooltipIncome(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-income');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-income';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.barchart-income');
        chartContainer.appendChild(tooltipEl);
      }

      const tooltipModel = context.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }

      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const bodyLines = [
          `
          <div style="font-size:14px !important">${this.$t('month')} ${this.$moment(data.date, "YYYY-MM").format('MMMM YYYY')}</div>
          <div class="divider-solid"></div>
          <div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('income.title')}:
            </div>
            <div style="text-align: right;">
             ${this.$helper.toCurrency(parseFloat(data.x || 0), null, { isSuffixSign: true })}
            </div>
          </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('area.amount_renter_this_month')}:
            </div>
            <div style="text-align: right;">
              ${parseFloat(data.detailRental.areaOccupied || 0).toFixed(2)} ${this.$t('area.space')}
            </div>
          </div>`,
        ];

        if (data.bfDetail && data.bfRentalDetail) {
          let bfMonthTotalValue = parseFloat(data.detail.totalValue - (data.bfDetail ? data.bfDetail.totalValue : 0)).toFixed(2)
          let bfMonthAreaOuccupied = parseFloat(data.detailRental.areaOccupied - data.bfRentalDetail.areaOccupied).toFixed(2)
          bodyLines.push(
            `
            <div class="divider-dashed"></div>
            <div class="d-flex justify-between">
              <div style="text-align: left;">${this.$t('income.difference_income_from_previous_month')}:</div>
              <div style="text-align: right;color:${this.getColorCurrency(bfMonthTotalValue)};">
                ${this.$helper.toCurrency(bfMonthTotalValue, null, { isSuffixSign: true })}
              </div>
            </div>`,
            `
            <div class="d-flex justify-between">
              <div style="text-align: left;">${this.$t('area.difference_renter_from_previous_month')}:</div>
              <div style="text-align: right;color:${this.getColorCurrency(bfMonthAreaOuccupied)};">
                ${this.$helper.toCurrency(bfMonthAreaOuccupied)} ${this.$t('area.space')}
              </div>
            </div>`);
        }

        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;

        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        const tooltipWidth = tooltipEl.offsetWidth;
        const chartContainer = document.querySelector('.barchart-income');
        const chartWidth = chartContainer.clientWidth;

        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10;
        }

        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    externalTooltipPieIncome(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-pie-income');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-pie-income';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.chart-pie-income-box');
        chartContainer.appendChild(tooltipEl);
      }
      const tooltipModel = context.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }
      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const color = tooltipModel.dataPoints[0].element.options.backgroundColor;
        const bodyLines = [
          `
          <div style="font-size:14px !important"> 
            <div class="d-flex align-center">
              <div class="legend-color-dot" style="background-color:${color}"></div>
              <div>${data.name} (${this.$helper.toCurrency(data.percent)}%)</div>  
            </div>
          </div>
          <div class="divider-solid"></div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('payment.all_income')}
            </div>
            <div style="text-align: right;">
            ${this.$helper.toCurrency(parseFloat(data.value || 0), null, { isSuffixSign: true })}
            </div>
          </div>`,

        ];
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;

        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        const tooltipWidth = tooltipEl.offsetWidth;
        const chartContainer = document.querySelector('.chart-pie-income-box');
        const chartWidth = chartContainer.clientWidth;

        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10;
        }

        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    externalTooltipDoughnut(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-doughnut');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-doughnut';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.doughnut-chart-box');
        chartContainer.appendChild(tooltipEl);
      }

      const tooltipModel = context.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }

      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const color = tooltipModel.dataPoints[0].element.options.backgroundColor;
        const bodyLines = [
          `
          <div style="font-size:14px !important"> 
            <div class="d-flex align-center">
              <div class="legend-color-dot" style="background-color:${color}"></div>
              <div>${data.name} (${this.$helper.toCurrency(data.value)}%)</div>  
            </div>
          </div>
          <div class="divider-solid"></div>
          <div class="d-flex justify-between">
              <div style="text-align: left;">
               ${this.$t('income.top_income')}
              </div>
              <div style="text-align: right;">
                ${this.$t('rank')} ${data.rank}
              </div>
            </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('payment.all_income')}
            </div>
            <div style="text-align: right;">
            ${this.$helper.toCurrency(parseFloat(data.total || 0), null, { isSuffixSign: true })}
            </div>
          </div>`,

        ];
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;

        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        const tooltipWidth = tooltipEl.offsetWidth;
        const chartContainer = document.querySelector('.doughnut-chart-box');
        const chartWidth = chartContainer.clientWidth;

        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10;
        }

        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    externalTooltipProductCategory(context) {
      let tooltipEl = document.getElementById('chartjs-tooltip-product-category');
      if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip-product-category';
        tooltipEl.innerHTML = '<div class="inner-tooltip"></div>';
        const chartContainer = document.querySelector('.pie-chart-box');
        chartContainer.appendChild(tooltipEl);
      }
      const tooltipModel = context?.tooltip;
      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        tooltipEl.style.visibility = 'hidden';
        return;
      }

      if (tooltipModel.body) {
        const data = context.tooltip.dataPoints[0].raw;
        const color = tooltipModel.dataPoints[0].element.options.backgroundColor;
        const bodyLines = [
          `
          <div style="font-size:14px !important">
            <div class="d-flex align-center">
              <div class="legend-color-dot" style="background-color:${color}"></div>
              <div>${data.name} (${this.$helper.toCurrency(data.value)}%)</div>  
            </div>
          </div>
          <div class="divider-solid"></div>
          <div class="d-flex justify-between">
              <div style="text-align: left;">
               ${this.$t('income.top_income')}
              </div>
              <div style="text-align: right;">
                ${this.$t('rank')} ${data.rank}
              </div>
            </div>`,
          `<div class="d-flex justify-between">
            <div style="text-align: left;">
              ${this.$t('area.sold_stall')}
            </div>
            <div style="text-align: right;">
              ${this.$helper.toCurrency(data.detail.count)} ${this.$t('area.space')}
            </div>
          </div>`,

        ];
        let html = '';
        bodyLines.forEach(line => {
          html += `<div>${line}</div>`;
        });
        tooltipEl.querySelector('.inner-tooltip').innerHTML = html;

        let left = tooltipModel.caretX;
        let top = tooltipModel.caretY;
        tooltipEl.style.opacity = 1;
        tooltipEl.style.visibility = 'visible';
        tooltipEl.style.position = 'absolute';

        const tooltipWidth = tooltipEl.offsetWidth;
        const chartContainer = document.querySelector('.pie-chart-box');
        const chartWidth = chartContainer.clientWidth;

        if (left + tooltipWidth > chartWidth) {
          left = chartWidth - tooltipWidth - 10;
        }

        tooltipEl.style.left = `${left}px`;
        tooltipEl.style.top = `${top}px`;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.color = 'white';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.padding = '10px';
      }
    },
    generateColors(count) {
      const colors = [];
      for (let i = 0; i < count; i++) {
        const r = (Math.random() * 255).toFixed(2);
        const g = (Math.random() * 255).toFixed(2);
        const b = (Math.random() * 255).toFixed(2);
        colors.push(`rgb(${r}, ${g}, ${b})`);
      }
      return colors;
    },
    getColorCurrency(v) {
      return v || v == 0 ? (v >= 0 ? '#62EC68' : '#EF5350') : ''
    },
    getTextCurrency(v, type = 'bath') {
      if (type == 'bath') {
        return v || v == 0 ? this.$helper.toCurrency(v, null, { isSuffixSign: true, isShowPlus: true }) : '-'
      } else if (type == 'percent') {
        return v || v == 0 ? this.$helper.toCurrency(v, null, { isShowPlus: true }) + '%' : '-'
      }
    },
    getRateClass(rateType) {
      return {
        'txt-success': rateType === 'plus',
        'txt-danger': rateType === 'minus'
      };
    }
  },
}


</script>
<style scoped lang="scss">
.disable-events {
  pointer-events: none
}

.box-areaplan {
  height: calc(100vh - 190px);
  background-color: #fff;
  border-radius: 15px;
  overflow: hidden;
}

.barchart-income {
  height: 320px;

}

.tooltip-box {
  .txt-hl {
    display: flex;
    font-weight: 700;
  }

  .txt-success {
    color: #62EC68;
  }

  .txt-danger {
    color: #EF5350;
  }

  .percent {
    display: flex;
    font-size: 14px;
    align-items: center;
    font-weight: 500;

    .icon {
      margin-right: 5px
    }

    img {
      width: 20px;
    }
  }
}

.position-relative {
  position: relative;
}

.intro-header {
  background-color: #fff;
  font-size: 24px;
  font-weight: 700;
  padding: 10px 20px;
  margin: 0 -10px;
}

.box-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 30px;

  & .txt-title {
    font-size: 24px;
    font-weight: 700;
  }

  & .filter {
    display: flex;
    gap: 10px;
    align-items: center;
  }
}


.scope-card-summary {
  font-family: 'Prompt';

  .box-summary {
    border-radius: 5px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &.active {
      border: 1px solid #4CAF50;
      box-shadow: 0px 12px 44px 0px #0000001F !important;
    }

    .title {
      font-size: 20px;
      color: #777777;
    }

    .count {
      font-size: 24px;
      font-weight: 700;
    }

    .txt-success {
      color: #4CAF50;
    }

    .txt-danger {
      color: #DE6765;
    }

    .percent {
      display: flex;
      font-size: 16px;
      align-items: center;

      .icon {
        margin-right: 5px
      }

      img {
        width: 20px;
      }
    }

    .chart {
      width: 120px;
      height: 70px;
    }
  }
}

.bar-chart-box {
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;

    .txt-title {
      font-size: 24px;
      font-weight: 700;
    }

    .secondary {
      color: #9291A5;
    }
  }

  canvas {
    width: auto;
    max-width: calc(100vw - 24px - 32px - 20px);
    min-height: 50vh;
    height: 50vh;
  }
}

.scope-container-overview {
  display: flex;
  gap: 20px;

  .grid-col {
    width: 50%;
  }

  @media screen and (max-width:992px) {
    & {
      display: block;

      .grid-col {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }

  .box-rank {
    .wrapper {
      border-radius: 10px;
      padding: 20px 0;
    }

    .header {
      display: flex;
      justify-content: space-between;
      padding: 0 15px;

      .txt-title {
        font-size: 24px;
        font-weight: 700;
      }

      .sub-title {
        font-size: 20px;
        font-weight: 400;
        color: #777777;
      }
    }

    .body {
      height: 786px;
      min-height: 786px;
      max-height: 786px;
      overflow-y: auto;
      padding: 0 15px;

      @media screen and (max-width:992px) {
        & {
          max-height: 400px;
        }
      }

      &.bg-warning {
        .number {
          background: rgba(239, 194, 80, 0.3);
          color: #EFC250;
        }

        &::-webkit-scrollbar {
          background: rgba(239, 194, 80, 0.12);
          width: 5px;
          height: 8px;
          border-radius: 15px;
        }

        &::-webkit-scrollbar-thumb {
          background: #EFC250;
          border-radius: 15px;
        }

        .box-rank-market.active {
          border: 1px solid #EFC250;
        }
      }

      &.bg-green {
        .number {
          background: rgba(76, 175, 80, 0.12);
          color: #4CAF50;
        }

        &::-webkit-scrollbar {
          background: rgba(76, 175, 80, 0.12);
          width: 5px;
          height: 8px;
          border-radius: 15px;
        }

        &::-webkit-scrollbar-thumb {
          background: #4CAF50;
          border-radius: 15px;
        }

        .box-rank-market.active {
          border: 1px solid #4CAF50;
        }
      }

      &.bg-blue {
        .number {
          background: rgba(40, 91, 162, 0.2);
          color: #285BA2;
        }

        &::-webkit-scrollbar {
          background: rgba(40, 91, 162, 0.2);
          width: 5px;
          height: 8px;
          border-radius: 15px;
        }

        &::-webkit-scrollbar-thumb {
          background: #285BA2;
          border-radius: 15px;
        }

        .box-rank-market.active {
          border: 1px solid #285BA2;
        }
      }

      &.bg-orange {
        .number {
          background: rgba(228, 125, 50, 0.2);
          color: #E47D32;
        }

        &::-webkit-scrollbar {
          background: rgba(228, 125, 50, 0.2);
          width: 5px;
          height: 8px;
          border-radius: 15px;
        }

        &::-webkit-scrollbar-thumb {
          background: #E47D32;
          border-radius: 15px;
        }

        .box-rank-market.active {
          border: 1px solid #E47D32;
        }
      }

      .box-rank-market {
        border-radius: 10px;
        box-shadow: 0px 3px 15px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        padding: 10px;
        justify-content: space-between;
        cursor: pointer;

        &:not(:last-child) {
          margin-bottom: 10px;
        }

        .detail {
          display: flex;
          align-items: center;

          .number {
            font-size: 24px;
            border-radius: 100%;
            min-width: 52px;
            height: 52px;
            width: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            margin-right: 10px;
          }

          .sub-title {
            font-size: 14px;
            font-weight: 400;
            color: #777777;
          }

          .name {
            font-size: 24px;
          }
        }

        .progress {
          min-width: 250px;
          display: flex;
          align-items: center;
          gap: 10px;
          position: relative;

          .box-abs-chart-mini {
            position: relative;
            width: 100%;
            height: 32px;
          }

          .chart-mini {
            position: absolute;
            left: -8px;
            height: 40px;
            top: 0px;
            // max-width: 255px;
            width: 100%;
          }

          .abs-progress-bar {
            position: absolute;
            bottom: 0;
          }

          .percent {
            font-size: 20px;
          }
        }
      }
    }
  }

  .box-chart-income {
    border-radius: 10px;
    min-height: 430px;
    height: 430px;
    background-color: #fff;

    .wrapper {
      // height: 450px;
      padding: 10px 15px;
      border-radius: 10px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .txt-title {
        font-size: 24px;
        font-weight: 700;
      }

      .sub-title {
        font-size: 20px;
        font-weight: 400;
        color: #777777;
      }
    }
  }

  .box-chart-type {
    border-radius: 10px;

    .wrapper {
      height: 450px;
      padding: 10px 15px;
      border-radius: 10px;
      display: flex;
    }

    .col-left {
      border-right: 1px solid rgba(0, 0, 0, 0.12);
      width: 50%;
      display: flex;
      flex-direction: column;

      .header {
        .txt-title {
          font-size: 24px;
          font-weight: 700;
        }

        .sub-title {
          font-size: 20px;
          font-weight: 400;
          color: #777777;
        }
      }

      .body {
        flex: 1;
        align-items: center;
        display: flex;
        justify-content: center;
      }

      .product-category {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        max-height: 300px;
        overflow-y: auto;

        .color {
          display: inline-block;
          width: 25px;
          height: 25px;
          border-radius: 100%;
          background-color: #4CAF50;
        }

        .name {
          font-size: 16px;
          font-weight: 400;
        }
      }
    }

    .col-right {
      padding: 10px;
      width: 50%;

      .no-data {
        font-size: 24px;
        text-align: center;
      }
    }
  }
}

.bd-bottom {
  border-bottom: 10px solid #4AAA4E;
}


.box-pie-income {
  .wrapper {
    display: flex;

    // align-items: center;
    @media screen and (max-width:992px) {
      flex-wrap: wrap;
    }

    .grid-col-1 {
      flex: 1;
      border-right: 1px solid #E5E5EF;

      .header {
        padding: 10px 20px;

        .txt-title {
          font-size: 24px;
          font-weight: 500;
        }

        .sub-title {
          color: #777777;
          font-size: 20px;
        }
      }

      .body {
        padding: 10px;

        .total-income-box {
          display: flex;
          align-items: center;
          height: 450px;
          justify-content: space-around;

          .doughnut-chart-box {
            max-width: 400px;
            width: 100%;

            canvas {
              width: auto;
            }
          }

          .market-legend {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            max-height: 400px;
            overflow-y: auto;

            .color {
              display: inline-block;
              width: 25px;
              height: 25px;
              border-radius: 100%;
              background-color: #4CAF50;
            }

            .name {
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
      }
    }

    .grid-col-2 {
      flex: 1;

      .total-income-box {
        display: flex;
        align-items: center;
        height: 450px;
        justify-content: space-around;
        flex-direction: reverse;

        .chart-pie-income-box {
          max-width: 450px;
          width: 100%;

          canvas {
            width: auto;
          }
        }

        .market-legend {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          margin-top: 125px;

          .color {
            display: inline-block;
            width: 25px;
            height: 25px;
            border-radius: 100%;
            background-color: #4CAF50;
          }

          .name {
            font-size: 16px;
            font-weight: 400;
          }
        }
      }
    }
  }
}

.tooltip-chart {
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  min-width: 300px;
}
</style>

<style lang="scss">
.floorplan,
.floorplan-box {
  border: none !important;
  border-radius: 15px !important;
  height: calc(100vh - 190px) !important;
}

#chartjs-tooltip-income,
#chartjs-tooltip-rental-rate,
#chartjs-tooltip-doughnut,
#chartjs-tooltip-product-category,
#chartjs-tooltip-pie-income,
#chartjs-tooltip-pie-income-dialog,
#chartjs-tooltip-product-category-dialog {
  font-size: 12px !important;
  min-width: 330px;
  transition: opacity 0.2s ease-in-out;
  z-index: 1000;

  .d-flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
  }

  .divider-solid {
    width: 100%;
    display: block;
    border: 1px solid #fff;
    margin: 5px 0;
  }

  .divider-dashed {
    width: 100%;
    display: block;
    border: 1px dashed #fff;
    margin: 5px 0;
  }

  .align-center {
    align-items: center;
  }

  .legend-color-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 5px;
  }

}

#chartjs-tooltip-rental-rate {
  min-width: 400px !important;
}

.box-chart-income,
.bar-chart-box {
  .legend-inline {
    display: flex;
  }

  .chart-legend {
    &-box {
      display: flex;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;
    }

    &-color {
      display: inline-block;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      align-items: center;
      margin-right: 10px;
    }

    &-text {
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.box-chart-type,
.total-income-box {
  .product-type {
    &-box {
      display: flex;
      // align-items: center;
      margin-right: 10px;
      cursor: pointer;
      margin-bottom: 10px;
    }

    &-color {
      display: inline-block;
      min-width: 25px;
      width: 25px;
      height: 25px;
      border-radius: 100%;
      align-items: center;
      margin-right: 10px;
      margin-top: 2px;
    }

    &-text {
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.vue-daterange-picker {
  .reportrange-text {
    background: #fff;
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 5px !important;
    border: 1px solid #a8a8a8;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .daterangepicker td.in-range {
    background-color: #E8F5E9;
    color: #2E7D32;
  }

  .daterangepicker td.active,
  .daterangepicker td.active:hover {
    background-color: var(--default-green) !important;
    border-color: transparent;
    color: #fff !important;
  }

  .daterangepicker td.off,
  .daterangepicker td.off.end-date,
  .daterangepicker td.off.in-range,
  .daterangepicker td.off.start-date {
    background-color: #fff !important;
    border-color: transparent;
    color: #999 !important;
  }


  .daterangepicker .ranges li.active {
    background-color: #E8F5E9;
    color: #2E7D32;
  }

  .btn {
    border-radius: 5px;
    font-size: 13px !important;
    font-weight: 500 !important;
    padding: 7px 16px !important;
  }
}
</style>